/******/ (function(modules) { // webpackBootstrap
/******/ 	var parentHotUpdateCallback = this["webpackHotUpdate"];
/******/ 	this["webpackHotUpdate"] = function webpackHotUpdateCallback(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		hotAddUpdateChunk(chunkId, moreModules);
/******/ 		if(parentHotUpdateCallback) parentHotUpdateCallback(chunkId, moreModules);
/******/ 	}
/******/
/******/ 	function hotDownloadUpdateChunk(chunkId) { // eslint-disable-line no-unused-vars
/******/ 		var head = document.getElementsByTagName("head")[0];
/******/ 		var script = document.createElement("script");
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = "utf-8";
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + hotCurrentHash + ".hot-update.js";
/******/ 		head.appendChild(script);
/******/ 	}
/******/
/******/ 	function hotDownloadManifest(callback) { // eslint-disable-line no-unused-vars
/******/ 		if(typeof XMLHttpRequest === "undefined")
/******/ 			return callback(new Error("No browser support"));
/******/ 		try {
/******/ 			var request = new XMLHttpRequest();
/******/ 			var requestPath = __webpack_require__.p + "" + hotCurrentHash + ".hot-update.json";
/******/ 			request.open("GET", requestPath, true);
/******/ 			request.timeout = 10000;
/******/ 			request.send(null);
/******/ 		} catch(err) {
/******/ 			return callback(err);
/******/ 		}
/******/ 		request.onreadystatechange = function() {
/******/ 			if(request.readyState !== 4) return;
/******/ 			if(request.status === 0) {
/******/ 				// timeout
/******/ 				callback(new Error("Manifest request to " + requestPath + " timed out."));
/******/ 			} else if(request.status === 404) {
/******/ 				// no update available
/******/ 				callback();
/******/ 			} else if(request.status !== 200 && request.status !== 304) {
/******/ 				// other failure
/******/ 				callback(new Error("Manifest request to " + requestPath + " failed."));
/******/ 			} else {
/******/ 				// success
/******/ 				try {
/******/ 					var update = JSON.parse(request.responseText);
/******/ 				} catch(e) {
/******/ 					callback(e);
/******/ 					return;
/******/ 				}
/******/ 				callback(null, update);
/******/ 			}
/******/ 		};
/******/ 	}
/******/
/******/
/******/ 	// Copied from https://github.com/facebook/react/blob/bef45b0/src/shared/utils/canDefineProperty.js
/******/ 	var canDefineProperty = false;
/******/ 	try {
/******/ 		Object.defineProperty({}, "x", {
/******/ 			get: function() {}
/******/ 		});
/******/ 		canDefineProperty = true;
/******/ 	} catch(x) {
/******/ 		// IE will fail on defineProperty
/******/ 	}
/******/
/******/ 	var hotApplyOnUpdate = true;
/******/ 	var hotCurrentHash = "90419a3134a9060be94b"; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentModuleData = {};
/******/ 	var hotCurrentParents = []; // eslint-disable-line no-unused-vars
/******/
/******/ 	function hotCreateRequire(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var me = installedModules[moduleId];
/******/ 		if(!me) return __webpack_require__;
/******/ 		var fn = function(request) {
/******/ 			if(me.hot.active) {
/******/ 				if(installedModules[request]) {
/******/ 					if(installedModules[request].parents.indexOf(moduleId) < 0)
/******/ 						installedModules[request].parents.push(moduleId);
/******/ 					if(me.children.indexOf(request) < 0)
/******/ 						me.children.push(request);
/******/ 				} else hotCurrentParents = [moduleId];
/******/ 			} else {
/******/ 				console.warn("[HMR] unexpected require(" + request + ") from disposed module " + moduleId);
/******/ 				hotCurrentParents = [];
/******/ 			}
/******/ 			return __webpack_require__(request);
/******/ 		};
/******/ 		for(var name in __webpack_require__) {
/******/ 			if(Object.prototype.hasOwnProperty.call(__webpack_require__, name)) {
/******/ 				if(canDefineProperty) {
/******/ 					Object.defineProperty(fn, name, (function(name) {
/******/ 						return {
/******/ 							configurable: true,
/******/ 							enumerable: true,
/******/ 							get: function() {
/******/ 								return __webpack_require__[name];
/******/ 							},
/******/ 							set: function(value) {
/******/ 								__webpack_require__[name] = value;
/******/ 							}
/******/ 						};
/******/ 					}(name)));
/******/ 				} else {
/******/ 					fn[name] = __webpack_require__[name];
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		function ensure(chunkId, callback) {
/******/ 			if(hotStatus === "ready")
/******/ 				hotSetStatus("prepare");
/******/ 			hotChunksLoading++;
/******/ 			__webpack_require__.e(chunkId, function() {
/******/ 				try {
/******/ 					callback.call(null, fn);
/******/ 				} finally {
/******/ 					finishChunkLoading();
/******/ 				}
/******/
/******/ 				function finishChunkLoading() {
/******/ 					hotChunksLoading--;
/******/ 					if(hotStatus === "prepare") {
/******/ 						if(!hotWaitingFilesMap[chunkId]) {
/******/ 							hotEnsureUpdateChunk(chunkId);
/******/ 						}
/******/ 						if(hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 							hotUpdateDownloaded();
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 			});
/******/ 		}
/******/ 		if(canDefineProperty) {
/******/ 			Object.defineProperty(fn, "e", {
/******/ 				enumerable: true,
/******/ 				value: ensure
/******/ 			});
/******/ 		} else {
/******/ 			fn.e = ensure;
/******/ 		}
/******/ 		return fn;
/******/ 	}
/******/
/******/ 	function hotCreateModule(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var hot = {
/******/ 			// private stuff
/******/ 			_acceptedDependencies: {},
/******/ 			_declinedDependencies: {},
/******/ 			_selfAccepted: false,
/******/ 			_selfDeclined: false,
/******/ 			_disposeHandlers: [],
/******/
/******/ 			// Module API
/******/ 			active: true,
/******/ 			accept: function(dep, callback) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfAccepted = true;
/******/ 				else if(typeof dep === "function")
/******/ 					hot._selfAccepted = dep;
/******/ 				else if(typeof dep === "object")
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._acceptedDependencies[dep[i]] = callback;
/******/ 				else
/******/ 					hot._acceptedDependencies[dep] = callback;
/******/ 			},
/******/ 			decline: function(dep) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfDeclined = true;
/******/ 				else if(typeof dep === "number")
/******/ 					hot._declinedDependencies[dep] = true;
/******/ 				else
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._declinedDependencies[dep[i]] = true;
/******/ 			},
/******/ 			dispose: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			addDisposeHandler: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			removeDisposeHandler: function(callback) {
/******/ 				var idx = hot._disposeHandlers.indexOf(callback);
/******/ 				if(idx >= 0) hot._disposeHandlers.splice(idx, 1);
/******/ 			},
/******/
/******/ 			// Management API
/******/ 			check: hotCheck,
/******/ 			apply: hotApply,
/******/ 			status: function(l) {
/******/ 				if(!l) return hotStatus;
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			addStatusHandler: function(l) {
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			removeStatusHandler: function(l) {
/******/ 				var idx = hotStatusHandlers.indexOf(l);
/******/ 				if(idx >= 0) hotStatusHandlers.splice(idx, 1);
/******/ 			},
/******/
/******/ 			//inherit from previous dispose call
/******/ 			data: hotCurrentModuleData[moduleId]
/******/ 		};
/******/ 		return hot;
/******/ 	}
/******/
/******/ 	var hotStatusHandlers = [];
/******/ 	var hotStatus = "idle";
/******/
/******/ 	function hotSetStatus(newStatus) {
/******/ 		hotStatus = newStatus;
/******/ 		for(var i = 0; i < hotStatusHandlers.length; i++)
/******/ 			hotStatusHandlers[i].call(null, newStatus);
/******/ 	}
/******/
/******/ 	// while downloading
/******/ 	var hotWaitingFiles = 0;
/******/ 	var hotChunksLoading = 0;
/******/ 	var hotWaitingFilesMap = {};
/******/ 	var hotRequestedFilesMap = {};
/******/ 	var hotAvailibleFilesMap = {};
/******/ 	var hotCallback;
/******/
/******/ 	// The update info
/******/ 	var hotUpdate, hotUpdateNewHash;
/******/
/******/ 	function toModuleId(id) {
/******/ 		var isNumber = (+id) + "" === id;
/******/ 		return isNumber ? +id : id;
/******/ 	}
/******/
/******/ 	function hotCheck(apply, callback) {
/******/ 		if(hotStatus !== "idle") throw new Error("check() is only allowed in idle status");
/******/ 		if(typeof apply === "function") {
/******/ 			hotApplyOnUpdate = false;
/******/ 			callback = apply;
/******/ 		} else {
/******/ 			hotApplyOnUpdate = apply;
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/ 		hotSetStatus("check");
/******/ 		hotDownloadManifest(function(err, update) {
/******/ 			if(err) return callback(err);
/******/ 			if(!update) {
/******/ 				hotSetStatus("idle");
/******/ 				callback(null, null);
/******/ 				return;
/******/ 			}
/******/
/******/ 			hotRequestedFilesMap = {};
/******/ 			hotAvailibleFilesMap = {};
/******/ 			hotWaitingFilesMap = {};
/******/ 			for(var i = 0; i < update.c.length; i++)
/******/ 				hotAvailibleFilesMap[update.c[i]] = true;
/******/ 			hotUpdateNewHash = update.h;
/******/
/******/ 			hotSetStatus("prepare");
/******/ 			hotCallback = callback;
/******/ 			hotUpdate = {};
/******/ 			var chunkId = 0;
/******/ 			{ // eslint-disable-line no-lone-blocks
/******/ 				/*globals chunkId */
/******/ 				hotEnsureUpdateChunk(chunkId);
/******/ 			}
/******/ 			if(hotStatus === "prepare" && hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 				hotUpdateDownloaded();
/******/ 			}
/******/ 		});
/******/ 	}
/******/
/******/ 	function hotAddUpdateChunk(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		if(!hotAvailibleFilesMap[chunkId] || !hotRequestedFilesMap[chunkId])
/******/ 			return;
/******/ 		hotRequestedFilesMap[chunkId] = false;
/******/ 		for(var moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				hotUpdate[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(--hotWaitingFiles === 0 && hotChunksLoading === 0) {
/******/ 			hotUpdateDownloaded();
/******/ 		}
/******/ 	}
/******/
/******/ 	function hotEnsureUpdateChunk(chunkId) {
/******/ 		if(!hotAvailibleFilesMap[chunkId]) {
/******/ 			hotWaitingFilesMap[chunkId] = true;
/******/ 		} else {
/******/ 			hotRequestedFilesMap[chunkId] = true;
/******/ 			hotWaitingFiles++;
/******/ 			hotDownloadUpdateChunk(chunkId);
/******/ 		}
/******/ 	}
/******/
/******/ 	function hotUpdateDownloaded() {
/******/ 		hotSetStatus("ready");
/******/ 		var callback = hotCallback;
/******/ 		hotCallback = null;
/******/ 		if(!callback) return;
/******/ 		if(hotApplyOnUpdate) {
/******/ 			hotApply(hotApplyOnUpdate, callback);
/******/ 		} else {
/******/ 			var outdatedModules = [];
/******/ 			for(var id in hotUpdate) {
/******/ 				if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 					outdatedModules.push(toModuleId(id));
/******/ 				}
/******/ 			}
/******/ 			callback(null, outdatedModules);
/******/ 		}
/******/ 	}
/******/
/******/ 	function hotApply(options, callback) {
/******/ 		if(hotStatus !== "ready") throw new Error("apply() is only allowed in ready status");
/******/ 		if(typeof options === "function") {
/******/ 			callback = options;
/******/ 			options = {};
/******/ 		} else if(options && typeof options === "object") {
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		} else {
/******/ 			options = {};
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/
/******/ 		function getAffectedStuff(module) {
/******/ 			var outdatedModules = [module];
/******/ 			var outdatedDependencies = {};
/******/
/******/ 			var queue = outdatedModules.slice();
/******/ 			while(queue.length > 0) {
/******/ 				var moduleId = queue.pop();
/******/ 				var module = installedModules[moduleId];
/******/ 				if(!module || module.hot._selfAccepted)
/******/ 					continue;
/******/ 				if(module.hot._selfDeclined) {
/******/ 					return new Error("Aborted because of self decline: " + moduleId);
/******/ 				}
/******/ 				if(moduleId === 0) {
/******/ 					return;
/******/ 				}
/******/ 				for(var i = 0; i < module.parents.length; i++) {
/******/ 					var parentId = module.parents[i];
/******/ 					var parent = installedModules[parentId];
/******/ 					if(parent.hot._declinedDependencies[moduleId]) {
/******/ 						return new Error("Aborted because of declined dependency: " + moduleId + " in " + parentId);
/******/ 					}
/******/ 					if(outdatedModules.indexOf(parentId) >= 0) continue;
/******/ 					if(parent.hot._acceptedDependencies[moduleId]) {
/******/ 						if(!outdatedDependencies[parentId])
/******/ 							outdatedDependencies[parentId] = [];
/******/ 						addAllToSet(outdatedDependencies[parentId], [moduleId]);
/******/ 						continue;
/******/ 					}
/******/ 					delete outdatedDependencies[parentId];
/******/ 					outdatedModules.push(parentId);
/******/ 					queue.push(parentId);
/******/ 				}
/******/ 			}
/******/
/******/ 			return [outdatedModules, outdatedDependencies];
/******/ 		}
/******/
/******/ 		function addAllToSet(a, b) {
/******/ 			for(var i = 0; i < b.length; i++) {
/******/ 				var item = b[i];
/******/ 				if(a.indexOf(item) < 0)
/******/ 					a.push(item);
/******/ 			}
/******/ 		}
/******/
/******/ 		// at begin all updates modules are outdated
/******/ 		// the "outdated" status can propagate to parents if they don't accept the children
/******/ 		var outdatedDependencies = {};
/******/ 		var outdatedModules = [];
/******/ 		var appliedUpdate = {};
/******/ 		for(var id in hotUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 				var moduleId = toModuleId(id);
/******/ 				var result = getAffectedStuff(moduleId);
/******/ 				if(!result) {
/******/ 					if(options.ignoreUnaccepted)
/******/ 						continue;
/******/ 					hotSetStatus("abort");
/******/ 					return callback(new Error("Aborted because " + moduleId + " is not accepted"));
/******/ 				}
/******/ 				if(result instanceof Error) {
/******/ 					hotSetStatus("abort");
/******/ 					return callback(result);
/******/ 				}
/******/ 				appliedUpdate[moduleId] = hotUpdate[moduleId];
/******/ 				addAllToSet(outdatedModules, result[0]);
/******/ 				for(var moduleId in result[1]) {
/******/ 					if(Object.prototype.hasOwnProperty.call(result[1], moduleId)) {
/******/ 						if(!outdatedDependencies[moduleId])
/******/ 							outdatedDependencies[moduleId] = [];
/******/ 						addAllToSet(outdatedDependencies[moduleId], result[1][moduleId]);
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// Store self accepted outdated modules to require them later by the module system
/******/ 		var outdatedSelfAcceptedModules = [];
/******/ 		for(var i = 0; i < outdatedModules.length; i++) {
/******/ 			var moduleId = outdatedModules[i];
/******/ 			if(installedModules[moduleId] && installedModules[moduleId].hot._selfAccepted)
/******/ 				outdatedSelfAcceptedModules.push({
/******/ 					module: moduleId,
/******/ 					errorHandler: installedModules[moduleId].hot._selfAccepted
/******/ 				});
/******/ 		}
/******/
/******/ 		// Now in "dispose" phase
/******/ 		hotSetStatus("dispose");
/******/ 		var queue = outdatedModules.slice();
/******/ 		while(queue.length > 0) {
/******/ 			var moduleId = queue.pop();
/******/ 			var module = installedModules[moduleId];
/******/ 			if(!module) continue;
/******/
/******/ 			var data = {};
/******/
/******/ 			// Call dispose handlers
/******/ 			var disposeHandlers = module.hot._disposeHandlers;
/******/ 			for(var j = 0; j < disposeHandlers.length; j++) {
/******/ 				var cb = disposeHandlers[j];
/******/ 				cb(data);
/******/ 			}
/******/ 			hotCurrentModuleData[moduleId] = data;
/******/
/******/ 			// disable module (this disables requires from this module)
/******/ 			module.hot.active = false;
/******/
/******/ 			// remove module from cache
/******/ 			delete installedModules[moduleId];
/******/
/******/ 			// remove "parents" references from all children
/******/ 			for(var j = 0; j < module.children.length; j++) {
/******/ 				var child = installedModules[module.children[j]];
/******/ 				if(!child) continue;
/******/ 				var idx = child.parents.indexOf(moduleId);
/******/ 				if(idx >= 0) {
/******/ 					child.parents.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// remove outdated dependency from module children
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				for(var j = 0; j < moduleOutdatedDependencies.length; j++) {
/******/ 					var dependency = moduleOutdatedDependencies[j];
/******/ 					var idx = module.children.indexOf(dependency);
/******/ 					if(idx >= 0) module.children.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// Not in "apply" phase
/******/ 		hotSetStatus("apply");
/******/
/******/ 		hotCurrentHash = hotUpdateNewHash;
/******/
/******/ 		// insert new code
/******/ 		for(var moduleId in appliedUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(appliedUpdate, moduleId)) {
/******/ 				modules[moduleId] = appliedUpdate[moduleId];
/******/ 			}
/******/ 		}
/******/
/******/ 		// call accept handlers
/******/ 		var error = null;
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				var callbacks = [];
/******/ 				for(var i = 0; i < moduleOutdatedDependencies.length; i++) {
/******/ 					var dependency = moduleOutdatedDependencies[i];
/******/ 					var cb = module.hot._acceptedDependencies[dependency];
/******/ 					if(callbacks.indexOf(cb) >= 0) continue;
/******/ 					callbacks.push(cb);
/******/ 				}
/******/ 				for(var i = 0; i < callbacks.length; i++) {
/******/ 					var cb = callbacks[i];
/******/ 					try {
/******/ 						cb(outdatedDependencies);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/
/******/ 		// Load self accepted modules
/******/ 		for(var i = 0; i < outdatedSelfAcceptedModules.length; i++) {
/******/ 			var item = outdatedSelfAcceptedModules[i];
/******/ 			var moduleId = item.module;
/******/ 			hotCurrentParents = [moduleId];
/******/ 			try {
/******/ 				__webpack_require__(moduleId);
/******/ 			} catch(err) {
/******/ 				if(typeof item.errorHandler === "function") {
/******/ 					try {
/******/ 						item.errorHandler(err);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				} else if(!error)
/******/ 					error = err;
/******/ 			}
/******/ 		}
/******/
/******/ 		// handle errors in accept handlers and self accepted module load
/******/ 		if(error) {
/******/ 			hotSetStatus("fail");
/******/ 			return callback(error);
/******/ 		}
/******/
/******/ 		hotSetStatus("idle");
/******/ 		callback(null, outdatedModules);
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			hot: hotCreateModule(moduleId),
/******/ 			parents: hotCurrentParents,
/******/ 			children: []
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, hotCreateRequire(moduleId));
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// __webpack_hash__
/******/ 	__webpack_require__.h = function() { return hotCurrentHash; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return hotCreateRequire(0)(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {var Public_zh = __webpack_require__(3),
	    fonts = __webpack_require__(11),
	    zepto_touch = __webpack_require__(25);
	$(function () {
		var navmenu = $(".nav-menu");
		var hheight = window.innerHeight;
		var wweith = window.innerWidth;
		$("#navbar-toggle button").on('tap', function () {
			if ($("button").hasClass("close")) {
				$("button").removeClass("close");
				$(".moble-nav").removeClass("active");
			} else {
				$("button").addClass("close");
				$(".moble-nav").addClass("active");
			}
			if ($("#left_nav").hasClass("active")) {
				$("#left_nav").removeClass("active").addClass("close");
			}
			if ($(".language_nav").hasClass("active")) {
				$(".language_nav").removeClass("active");
			}
		});
		$(".navmenu").on('tap', function () {
			if ($(this).find('.nav-menu-icon').hasClass('nav-menu-rotate-back')) {
				$(this).find('.nav-menu-icon').removeClass("nav-menu-rotate-back").addClass("nav-menu-rotate");
				$(this).next(".nav-menu-li").addClass("active");
			} else {
				$(this).find('.nav-menu-icon').addClass("nav-menu-rotate-back").removeClass("nav-menu-rotate");
				$(this).next(".nav-menu-li").removeClass("active");
			}
		});
		$(".language").on('tap', function () {
			$(".language_nav").addClass("active");
			$(".moble-nav").removeClass("active");
		});
		window.addEventListener("load", function () {
			var btn = $(".foot_top");
			function goTop(acceleration, time) {
				//修改参数可调整返回顶部的速度
				acceleration = acceleration || 0.1;
				time = time || 10;
				var speed = 1 + acceleration;
	
				function getScrollTop() {
					//取得滚动条的竖直距离
					return document.documentElement.scrollTop || document.body.scrollTop;
				}
	
				function setScrollTop(value) {
					//设置滚动条的竖直距离,实现效果的关键就是在很短的间隔时间内不断地修改滚动条的竖直距离,以实现滚动效果
					document.documentElement.scrollTop = value;
					document.body.scrollTop = value;
				}
				window.onscroll = function () {
					var scrollTop = getScrollTop();
					if (scrollTop > 100) {
						//判断滚动条距离窗口顶部多远时显示出来，这里是100px
						//							btn.style.display = "block";
						btn.show();
					} else {
						//							btn.style.display = "none";
						btn.hide();
					}
				};
				btn.on('tap', function () {
					var timer = setInterval(function () {
						setScrollTop(Math.floor(getScrollTop() / speed)); //这行代码是关键，取得滚动条竖直距离，除以speed后再给滚动条设置竖直距离
						if (getScrollTop() == 0) clearInterval(timer);
					}, time);
				});
			}
			goTop(0.2, 8);
		}, false);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* Zepto v1.2.0 - zepto event ajax form ie - zeptojs.com/license */
	(function (global, factory) {
	    if (exports === 'object' && typeof module !== 'undefined') module.exports = factory(global);
	    if (true) !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	        return factory(global);
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else factory(global);
	})(typeof window !== "undefined" ? window : this, function (window) {
	    var Zepto = function () {
	        var undefined,
	            key,
	            $,
	            classList,
	            emptyArray = [],
	            concat = emptyArray.concat,
	            filter = emptyArray.filter,
	            slice = emptyArray.slice,
	            document = window.document,
	            elementDisplay = {},
	            classCache = {},
	            cssNumber = { 'column-count': 1, 'columns': 1, 'font-weight': 1, 'line-height': 1, 'opacity': 1, 'z-index': 1, 'zoom': 1 },
	            fragmentRE = /^\s*<(\w+|!)[^>]*>/,
	            singleTagRE = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
	            tagExpanderRE = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig,
	            rootNodeRE = /^(?:body|html)$/i,
	            capitalRE = /([A-Z])/g,
	
	
	        // special attributes that should be get/set via method calls
	        methodAttributes = ['val', 'css', 'html', 'text', 'data', 'width', 'height', 'offset'],
	            adjacencyOperators = ['after', 'prepend', 'before', 'append'],
	            table = document.createElement('table'),
	            tableRow = document.createElement('tr'),
	            containers = {
	            'tr': document.createElement('tbody'),
	            'tbody': table, 'thead': table, 'tfoot': table,
	            'td': tableRow, 'th': tableRow,
	            '*': document.createElement('div')
	        },
	            readyRE = /complete|loaded|interactive/,
	            simpleSelectorRE = /^[\w-]*$/,
	            class2type = {},
	            toString = class2type.toString,
	            zepto = {},
	            camelize,
	            uniq,
	            tempParent = document.createElement('div'),
	            propMap = {
	            'tabindex': 'tabIndex',
	            'readonly': 'readOnly',
	            'for': 'htmlFor',
	            'class': 'className',
	            'maxlength': 'maxLength',
	            'cellspacing': 'cellSpacing',
	            'cellpadding': 'cellPadding',
	            'rowspan': 'rowSpan',
	            'colspan': 'colSpan',
	            'usemap': 'useMap',
	            'frameborder': 'frameBorder',
	            'contenteditable': 'contentEditable'
	        },
	            isArray = Array.isArray || function (object) {
	            return object instanceof Array;
	        };
	
	        zepto.matches = function (element, selector) {
	            if (!selector || !element || element.nodeType !== 1) return false;
	            var matchesSelector = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.matchesSelector;
	            if (matchesSelector) return matchesSelector.call(element, selector);
	            // fall back to performing a selector:
	            var match,
	                parent = element.parentNode,
	                temp = !parent;
	            if (temp) (parent = tempParent).appendChild(element);
	            match = ~zepto.qsa(parent, selector).indexOf(element);
	            temp && tempParent.removeChild(element);
	            return match;
	        };
	
	        function type(obj) {
	            return obj == null ? String(obj) : class2type[toString.call(obj)] || "object";
	        }
	
	        function isFunction(value) {
	            return type(value) == "function";
	        }
	        function isWindow(obj) {
	            return obj != null && obj == obj.window;
	        }
	        function isDocument(obj) {
	            return obj != null && obj.nodeType == obj.DOCUMENT_NODE;
	        }
	        function isObject(obj) {
	            return type(obj) == "object";
	        }
	        function isPlainObject(obj) {
	            return isObject(obj) && !isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	        }
	
	        function likeArray(obj) {
	            var length = !!obj && 'length' in obj && obj.length,
	                type = $.type(obj);
	
	            return 'function' != type && !isWindow(obj) && ('array' == type || length === 0 || typeof length == 'number' && length > 0 && length - 1 in obj);
	        }
	
	        function compact(array) {
	            return filter.call(array, function (item) {
	                return item != null;
	            });
	        }
	        function flatten(array) {
	            return array.length > 0 ? $.fn.concat.apply([], array) : array;
	        }
	        camelize = function (str) {
	            return str.replace(/-+(.)?/g, function (match, chr) {
	                return chr ? chr.toUpperCase() : '';
	            });
	        };
	        function dasherize(str) {
	            return str.replace(/::/g, '/').replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2').replace(/([a-z\d])([A-Z])/g, '$1_$2').replace(/_/g, '-').toLowerCase();
	        }
	        uniq = function (array) {
	            return filter.call(array, function (item, idx) {
	                return array.indexOf(item) == idx;
	            });
	        };
	
	        function classRE(name) {
	            return name in classCache ? classCache[name] : classCache[name] = new RegExp('(^|\\s)' + name + '(\\s|$)');
	        }
	
	        function maybeAddPx(name, value) {
	            return typeof value == "number" && !cssNumber[dasherize(name)] ? value + "px" : value;
	        }
	
	        function defaultDisplay(nodeName) {
	            var element, display;
	            if (!elementDisplay[nodeName]) {
	                element = document.createElement(nodeName);
	                document.body.appendChild(element);
	                display = getComputedStyle(element, '').getPropertyValue("display");
	                element.parentNode.removeChild(element);
	                display == "none" && (display = "block");
	                elementDisplay[nodeName] = display;
	            }
	            return elementDisplay[nodeName];
	        }
	
	        function children(element) {
	            return 'children' in element ? slice.call(element.children) : $.map(element.childNodes, function (node) {
	                if (node.nodeType == 1) return node;
	            });
	        }
	
	        function Z(dom, selector) {
	            var i,
	                len = dom ? dom.length : 0;
	            for (i = 0; i < len; i++) this[i] = dom[i];
	            this.length = len;
	            this.selector = selector || '';
	        }
	
	        // `$.zepto.fragment` takes a html string and an optional tag name
	        // to generate DOM nodes from the given html string.
	        // The generated DOM nodes are returned as an array.
	        // This function can be overridden in plugins for example to make
	        // it compatible with browsers that don't support the DOM fully.
	        zepto.fragment = function (html, name, properties) {
	            var dom, nodes, container;
	
	            // A special case optimization for a single tag
	            if (singleTagRE.test(html)) dom = $(document.createElement(RegExp.$1));
	
	            if (!dom) {
	                if (html.replace) html = html.replace(tagExpanderRE, "<$1></$2>");
	                if (name === undefined) name = fragmentRE.test(html) && RegExp.$1;
	                if (!(name in containers)) name = '*';
	
	                container = containers[name];
	                container.innerHTML = '' + html;
	                dom = $.each(slice.call(container.childNodes), function () {
	                    container.removeChild(this);
	                });
	            }
	
	            if (isPlainObject(properties)) {
	                nodes = $(dom);
	                $.each(properties, function (key, value) {
	                    if (methodAttributes.indexOf(key) > -1) nodes[key](value);else nodes.attr(key, value);
	                });
	            }
	
	            return dom;
	        };
	
	        // `$.zepto.Z` swaps out the prototype of the given `dom` array
	        // of nodes with `$.fn` and thus supplying all the Zepto functions
	        // to the array. This method can be overridden in plugins.
	        zepto.Z = function (dom, selector) {
	            return new Z(dom, selector);
	        };
	
	        // `$.zepto.isZ` should return `true` if the given object is a Zepto
	        // collection. This method can be overridden in plugins.
	        zepto.isZ = function (object) {
	            return object instanceof zepto.Z;
	        };
	
	        // `$.zepto.init` is Zepto's counterpart to jQuery's `$.fn.init` and
	        // takes a CSS selector and an optional context (and handles various
	        // special cases).
	        // This method can be overridden in plugins.
	        zepto.init = function (selector, context) {
	            var dom;
	            // If nothing given, return an empty Zepto collection
	            if (!selector) return zepto.Z();
	            // Optimize for string selectors
	            else if (typeof selector == 'string') {
	                    selector = selector.trim();
	                    // If it's a html fragment, create nodes from it
	                    // Note: In both Chrome 21 and Firefox 15, DOM error 12
	                    // is thrown if the fragment doesn't begin with <
	                    if (selector[0] == '<' && fragmentRE.test(selector)) dom = zepto.fragment(selector, RegExp.$1, context), selector = null;
	                    // If there's a context, create a collection on that context first, and select
	                    // nodes from there
	                    else if (context !== undefined) return $(context).find(selector);
	                        // If it's a CSS selector, use it to select nodes.
	                        else dom = zepto.qsa(document, selector);
	                }
	                // If a function is given, call it when the DOM is ready
	                else if (isFunction(selector)) return $(document).ready(selector);
	                    // If a Zepto collection is given, just return it
	                    else if (zepto.isZ(selector)) return selector;else {
	                            // normalize array if an array of nodes is given
	                            if (isArray(selector)) dom = compact(selector);
	                            // Wrap DOM nodes.
	                            else if (isObject(selector)) dom = [selector], selector = null;
	                                // If it's a html fragment, create nodes from it
	                                else if (fragmentRE.test(selector)) dom = zepto.fragment(selector.trim(), RegExp.$1, context), selector = null;
	                                    // If there's a context, create a collection on that context first, and select
	                                    // nodes from there
	                                    else if (context !== undefined) return $(context).find(selector);
	                                        // And last but no least, if it's a CSS selector, use it to select nodes.
	                                        else dom = zepto.qsa(document, selector);
	                        }
	            // create a new Zepto collection from the nodes found
	            return zepto.Z(dom, selector);
	        };
	
	        // `$` will be the base `Zepto` object. When calling this
	        // function just call `$.zepto.init, which makes the implementation
	        // details of selecting nodes and creating Zepto collections
	        // patchable in plugins.
	        $ = function (selector, context) {
	            return zepto.init(selector, context);
	        };
	
	        function extend(target, source, deep) {
	            for (key in source) if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	                if (isPlainObject(source[key]) && !isPlainObject(target[key])) target[key] = {};
	                if (isArray(source[key]) && !isArray(target[key])) target[key] = [];
	                extend(target[key], source[key], deep);
	            } else if (source[key] !== undefined) target[key] = source[key];
	        }
	
	        // Copy all but undefined properties from one or more
	        // objects to the `target` object.
	        $.extend = function (target) {
	            var deep,
	                args = slice.call(arguments, 1);
	            if (typeof target == 'boolean') {
	                deep = target;
	                target = args.shift();
	            }
	            args.forEach(function (arg) {
	                extend(target, arg, deep);
	            });
	            return target;
	        };
	
	        // `$.zepto.qsa` is Zepto's CSS selector implementation which
	        // uses `document.querySelectorAll` and optimizes for some special cases, like `#id`.
	        // This method can be overridden in plugins.
	        zepto.qsa = function (element, selector) {
	            var found,
	                maybeID = selector[0] == '#',
	                maybeClass = !maybeID && selector[0] == '.',
	                nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	                // Ensure that a 1 char tag name still gets checked
	            isSimple = simpleSelectorRE.test(nameOnly);
	            return element.getElementById && isSimple && maybeID ? // Safari DocumentFragment doesn't have getElementById
	            (found = element.getElementById(nameOnly)) ? [found] : [] : element.nodeType !== 1 && element.nodeType !== 9 && element.nodeType !== 11 ? [] : slice.call(isSimple && !maybeID && element.getElementsByClassName ? // DocumentFragment doesn't have getElementsByClassName/TagName
	            maybeClass ? element.getElementsByClassName(nameOnly) : // If it's simple, it could be a class
	            element.getElementsByTagName(selector) : // Or a tag
	            element.querySelectorAll(selector) // Or it's not simple, and we need to query all
	            );
	        };
	
	        function filtered(nodes, selector) {
	            return selector == null ? $(nodes) : $(nodes).filter(selector);
	        }
	
	        $.contains = document.documentElement.contains ? function (parent, node) {
	            return parent !== node && parent.contains(node);
	        } : function (parent, node) {
	            while (node && (node = node.parentNode)) if (node === parent) return true;
	            return false;
	        };
	
	        function funcArg(context, arg, idx, payload) {
	            return isFunction(arg) ? arg.call(context, idx, payload) : arg;
	        }
	
	        function setAttribute(node, name, value) {
	            value == null ? node.removeAttribute(name) : node.setAttribute(name, value);
	        }
	
	        // access className property while respecting SVGAnimatedString
	        function className(node, value) {
	            var klass = node.className || '',
	                svg = klass && klass.baseVal !== undefined;
	
	            if (value === undefined) return svg ? klass.baseVal : klass;
	            svg ? klass.baseVal = value : node.className = value;
	        }
	
	        // "true"  => true
	        // "false" => false
	        // "null"  => null
	        // "42"    => 42
	        // "42.5"  => 42.5
	        // "08"    => "08"
	        // JSON    => parse if valid
	        // String  => self
	        function deserializeValue(value) {
	            try {
	                return value ? value == "true" || (value == "false" ? false : value == "null" ? null : +value + "" == value ? +value : /^[\[\{]/.test(value) ? $.parseJSON(value) : value) : value;
	            } catch (e) {
	                return value;
	            }
	        }
	
	        $.type = type;
	        $.isFunction = isFunction;
	        $.isWindow = isWindow;
	        $.isArray = isArray;
	        $.isPlainObject = isPlainObject;
	
	        $.isEmptyObject = function (obj) {
	            var name;
	            for (name in obj) return false;
	            return true;
	        };
	
	        $.isNumeric = function (val) {
	            var num = Number(val),
	                type = typeof val;
	            return val != null && type != 'boolean' && (type != 'string' || val.length) && !isNaN(num) && isFinite(num) || false;
	        };
	
	        $.inArray = function (elem, array, i) {
	            return emptyArray.indexOf.call(array, elem, i);
	        };
	
	        $.camelCase = camelize;
	        $.trim = function (str) {
	            return str == null ? "" : String.prototype.trim.call(str);
	        };
	
	        // plugin compatibility
	        $.uuid = 0;
	        $.support = {};
	        $.expr = {};
	        $.noop = function () {};
	
	        $.map = function (elements, callback) {
	            var value,
	                values = [],
	                i,
	                key;
	            if (likeArray(elements)) for (i = 0; i < elements.length; i++) {
	                value = callback(elements[i], i);
	                if (value != null) values.push(value);
	            } else for (key in elements) {
	                value = callback(elements[key], key);
	                if (value != null) values.push(value);
	            }
	            return flatten(values);
	        };
	
	        $.each = function (elements, callback) {
	            var i, key;
	            if (likeArray(elements)) {
	                for (i = 0; i < elements.length; i++) if (callback.call(elements[i], i, elements[i]) === false) return elements;
	            } else {
	                for (key in elements) if (callback.call(elements[key], key, elements[key]) === false) return elements;
	            }
	
	            return elements;
	        };
	
	        $.grep = function (elements, callback) {
	            return filter.call(elements, callback);
	        };
	
	        if (window.JSON) $.parseJSON = JSON.parse;
	
	        // Populate the class2type map
	        $.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (i, name) {
	            class2type["[object " + name + "]"] = name.toLowerCase();
	        });
	
	        // Define methods that will be available on all
	        // Zepto collections
	        $.fn = {
	            constructor: zepto.Z,
	            length: 0,
	
	            // Because a collection acts like an array
	            // copy over these useful array functions.
	            forEach: emptyArray.forEach,
	            reduce: emptyArray.reduce,
	            push: emptyArray.push,
	            sort: emptyArray.sort,
	            splice: emptyArray.splice,
	            indexOf: emptyArray.indexOf,
	            concat: function () {
	                var i,
	                    value,
	                    args = [];
	                for (i = 0; i < arguments.length; i++) {
	                    value = arguments[i];
	                    args[i] = zepto.isZ(value) ? value.toArray() : value;
	                }
	                return concat.apply(zepto.isZ(this) ? this.toArray() : this, args);
	            },
	
	            // `map` and `slice` in the jQuery API work differently
	            // from their array counterparts
	            map: function (fn) {
	                return $($.map(this, function (el, i) {
	                    return fn.call(el, i, el);
	                }));
	            },
	            slice: function () {
	                return $(slice.apply(this, arguments));
	            },
	
	            ready: function (callback) {
	                // need to check if document.body exists for IE as that browser reports
	                // document ready when it hasn't yet created the body element
	                if (readyRE.test(document.readyState) && document.body) callback($);else document.addEventListener('DOMContentLoaded', function () {
	                    callback($);
	                }, false);
	                return this;
	            },
	            get: function (idx) {
	                return idx === undefined ? slice.call(this) : this[idx >= 0 ? idx : idx + this.length];
	            },
	            toArray: function () {
	                return this.get();
	            },
	            size: function () {
	                return this.length;
	            },
	            remove: function () {
	                return this.each(function () {
	                    if (this.parentNode != null) this.parentNode.removeChild(this);
	                });
	            },
	            each: function (callback) {
	                emptyArray.every.call(this, function (el, idx) {
	                    return callback.call(el, idx, el) !== false;
	                });
	                return this;
	            },
	            filter: function (selector) {
	                if (isFunction(selector)) return this.not(this.not(selector));
	                return $(filter.call(this, function (element) {
	                    return zepto.matches(element, selector);
	                }));
	            },
	            add: function (selector, context) {
	                return $(uniq(this.concat($(selector, context))));
	            },
	            is: function (selector) {
	                return this.length > 0 && zepto.matches(this[0], selector);
	            },
	            not: function (selector) {
	                var nodes = [];
	                if (isFunction(selector) && selector.call !== undefined) this.each(function (idx) {
	                    if (!selector.call(this, idx)) nodes.push(this);
	                });else {
	                    var excludes = typeof selector == 'string' ? this.filter(selector) : likeArray(selector) && isFunction(selector.item) ? slice.call(selector) : $(selector);
	                    this.forEach(function (el) {
	                        if (excludes.indexOf(el) < 0) nodes.push(el);
	                    });
	                }
	                return $(nodes);
	            },
	            has: function (selector) {
	                return this.filter(function () {
	                    return isObject(selector) ? $.contains(this, selector) : $(this).find(selector).size();
	                });
	            },
	            eq: function (idx) {
	                return idx === -1 ? this.slice(idx) : this.slice(idx, +idx + 1);
	            },
	            first: function () {
	                var el = this[0];
	                return el && !isObject(el) ? el : $(el);
	            },
	            last: function () {
	                var el = this[this.length - 1];
	                return el && !isObject(el) ? el : $(el);
	            },
	            find: function (selector) {
	                var result,
	                    $this = this;
	                if (!selector) result = $();else if (typeof selector == 'object') result = $(selector).filter(function () {
	                    var node = this;
	                    return emptyArray.some.call($this, function (parent) {
	                        return $.contains(parent, node);
	                    });
	                });else if (this.length == 1) result = $(zepto.qsa(this[0], selector));else result = this.map(function () {
	                    return zepto.qsa(this, selector);
	                });
	                return result;
	            },
	            closest: function (selector, context) {
	                var nodes = [],
	                    collection = typeof selector == 'object' && $(selector);
	                this.each(function (_, node) {
	                    while (node && !(collection ? collection.indexOf(node) >= 0 : zepto.matches(node, selector))) node = node !== context && !isDocument(node) && node.parentNode;
	                    if (node && nodes.indexOf(node) < 0) nodes.push(node);
	                });
	                return $(nodes);
	            },
	            parents: function (selector) {
	                var ancestors = [],
	                    nodes = this;
	                while (nodes.length > 0) nodes = $.map(nodes, function (node) {
	                    if ((node = node.parentNode) && !isDocument(node) && ancestors.indexOf(node) < 0) {
	                        ancestors.push(node);
	                        return node;
	                    }
	                });
	                return filtered(ancestors, selector);
	            },
	            parent: function (selector) {
	                return filtered(uniq(this.pluck('parentNode')), selector);
	            },
	            children: function (selector) {
	                return filtered(this.map(function () {
	                    return children(this);
	                }), selector);
	            },
	            contents: function () {
	                return this.map(function () {
	                    return this.contentDocument || slice.call(this.childNodes);
	                });
	            },
	            siblings: function (selector) {
	                return filtered(this.map(function (i, el) {
	                    return filter.call(children(el.parentNode), function (child) {
	                        return child !== el;
	                    });
	                }), selector);
	            },
	            empty: function () {
	                return this.each(function () {
	                    this.innerHTML = '';
	                });
	            },
	            // `pluck` is borrowed from Prototype.js
	            pluck: function (property) {
	                return $.map(this, function (el) {
	                    return el[property];
	                });
	            },
	            show: function () {
	                return this.each(function () {
	                    this.style.display == "none" && (this.style.display = '');
	                    if (getComputedStyle(this, '').getPropertyValue("display") == "none") this.style.display = defaultDisplay(this.nodeName);
	                });
	            },
	            replaceWith: function (newContent) {
	                return this.before(newContent).remove();
	            },
	            wrap: function (structure) {
	                var func = isFunction(structure);
	                if (this[0] && !func) var dom = $(structure).get(0),
	                    clone = dom.parentNode || this.length > 1;
	
	                return this.each(function (index) {
	                    $(this).wrapAll(func ? structure.call(this, index) : clone ? dom.cloneNode(true) : dom);
	                });
	            },
	            wrapAll: function (structure) {
	                if (this[0]) {
	                    $(this[0]).before(structure = $(structure));
	                    var children;
	                    // drill down to the inmost element
	                    while ((children = structure.children()).length) structure = children.first();
	                    $(structure).append(this);
	                }
	                return this;
	            },
	            wrapInner: function (structure) {
	                var func = isFunction(structure);
	                return this.each(function (index) {
	                    var self = $(this),
	                        contents = self.contents(),
	                        dom = func ? structure.call(this, index) : structure;
	                    contents.length ? contents.wrapAll(dom) : self.append(dom);
	                });
	            },
	            unwrap: function () {
	                this.parent().each(function () {
	                    $(this).replaceWith($(this).children());
	                });
	                return this;
	            },
	            clone: function () {
	                return this.map(function () {
	                    return this.cloneNode(true);
	                });
	            },
	            hide: function () {
	                return this.css("display", "none");
	            },
	            toggle: function (setting) {
	                return this.each(function () {
	                    var el = $(this);(setting === undefined ? el.css("display") == "none" : setting) ? el.show() : el.hide();
	                });
	            },
	            prev: function (selector) {
	                return $(this.pluck('previousElementSibling')).filter(selector || '*');
	            },
	            next: function (selector) {
	                return $(this.pluck('nextElementSibling')).filter(selector || '*');
	            },
	            html: function (html) {
	                return 0 in arguments ? this.each(function (idx) {
	                    var originHtml = this.innerHTML;
	                    $(this).empty().append(funcArg(this, html, idx, originHtml));
	                }) : 0 in this ? this[0].innerHTML : null;
	            },
	            text: function (text) {
	                return 0 in arguments ? this.each(function (idx) {
	                    var newText = funcArg(this, text, idx, this.textContent);
	                    this.textContent = newText == null ? '' : '' + newText;
	                }) : 0 in this ? this.pluck('textContent').join("") : null;
	            },
	            attr: function (name, value) {
	                var result;
	                return typeof name == 'string' && !(1 in arguments) ? 0 in this && this[0].nodeType == 1 && (result = this[0].getAttribute(name)) != null ? result : undefined : this.each(function (idx) {
	                    if (this.nodeType !== 1) return;
	                    if (isObject(name)) for (key in name) setAttribute(this, key, name[key]);else setAttribute(this, name, funcArg(this, value, idx, this.getAttribute(name)));
	                });
	            },
	            removeAttr: function (name) {
	                return this.each(function () {
	                    this.nodeType === 1 && name.split(' ').forEach(function (attribute) {
	                        setAttribute(this, attribute);
	                    }, this);
	                });
	            },
	            prop: function (name, value) {
	                name = propMap[name] || name;
	                return 1 in arguments ? this.each(function (idx) {
	                    this[name] = funcArg(this, value, idx, this[name]);
	                }) : this[0] && this[0][name];
	            },
	            removeProp: function (name) {
	                name = propMap[name] || name;
	                return this.each(function () {
	                    delete this[name];
	                });
	            },
	            data: function (name, value) {
	                var attrName = 'data-' + name.replace(capitalRE, '-$1').toLowerCase();
	
	                var data = 1 in arguments ? this.attr(attrName, value) : this.attr(attrName);
	
	                return data !== null ? deserializeValue(data) : undefined;
	            },
	            val: function (value) {
	                if (0 in arguments) {
	                    if (value == null) value = "";
	                    return this.each(function (idx) {
	                        this.value = funcArg(this, value, idx, this.value);
	                    });
	                } else {
	                    return this[0] && (this[0].multiple ? $(this[0]).find('option').filter(function () {
	                        return this.selected;
	                    }).pluck('value') : this[0].value);
	                }
	            },
	            offset: function (coordinates) {
	                if (coordinates) return this.each(function (index) {
	                    var $this = $(this),
	                        coords = funcArg(this, coordinates, index, $this.offset()),
	                        parentOffset = $this.offsetParent().offset(),
	                        props = {
	                        top: coords.top - parentOffset.top,
	                        left: coords.left - parentOffset.left
	                    };
	
	                    if ($this.css('position') == 'static') props['position'] = 'relative';
	                    $this.css(props);
	                });
	                if (!this.length) return null;
	                if (document.documentElement !== this[0] && !$.contains(document.documentElement, this[0])) return { top: 0, left: 0 };
	                var obj = this[0].getBoundingClientRect();
	                return {
	                    left: obj.left + window.pageXOffset,
	                    top: obj.top + window.pageYOffset,
	                    width: Math.round(obj.width),
	                    height: Math.round(obj.height)
	                };
	            },
	            css: function (property, value) {
	                if (arguments.length < 2) {
	                    var element = this[0];
	                    if (typeof property == 'string') {
	                        if (!element) return;
	                        return element.style[camelize(property)] || getComputedStyle(element, '').getPropertyValue(property);
	                    } else if (isArray(property)) {
	                        if (!element) return;
	                        var props = {};
	                        var computedStyle = getComputedStyle(element, '');
	                        $.each(property, function (_, prop) {
	                            props[prop] = element.style[camelize(prop)] || computedStyle.getPropertyValue(prop);
	                        });
	                        return props;
	                    }
	                }
	
	                var css = '';
	                if (type(property) == 'string') {
	                    if (!value && value !== 0) this.each(function () {
	                        this.style.removeProperty(dasherize(property));
	                    });else css = dasherize(property) + ":" + maybeAddPx(property, value);
	                } else {
	                    for (key in property) if (!property[key] && property[key] !== 0) this.each(function () {
	                        this.style.removeProperty(dasherize(key));
	                    });else css += dasherize(key) + ':' + maybeAddPx(key, property[key]) + ';';
	                }
	
	                return this.each(function () {
	                    this.style.cssText += ';' + css;
	                });
	            },
	            index: function (element) {
	                return element ? this.indexOf($(element)[0]) : this.parent().children().indexOf(this[0]);
	            },
	            hasClass: function (name) {
	                if (!name) return false;
	                return emptyArray.some.call(this, function (el) {
	                    return this.test(className(el));
	                }, classRE(name));
	            },
	            addClass: function (name) {
	                if (!name) return this;
	                return this.each(function (idx) {
	                    if (!('className' in this)) return;
	                    classList = [];
	                    var cls = className(this),
	                        newName = funcArg(this, name, idx, cls);
	                    newName.split(/\s+/g).forEach(function (klass) {
	                        if (!$(this).hasClass(klass)) classList.push(klass);
	                    }, this);
	                    classList.length && className(this, cls + (cls ? " " : "") + classList.join(" "));
	                });
	            },
	            removeClass: function (name) {
	                return this.each(function (idx) {
	                    if (!('className' in this)) return;
	                    if (name === undefined) return className(this, '');
	                    classList = className(this);
	                    funcArg(this, name, idx, classList).split(/\s+/g).forEach(function (klass) {
	                        classList = classList.replace(classRE(klass), " ");
	                    });
	                    className(this, classList.trim());
	                });
	            },
	            toggleClass: function (name, when) {
	                if (!name) return this;
	                return this.each(function (idx) {
	                    var $this = $(this),
	                        names = funcArg(this, name, idx, className(this));
	                    names.split(/\s+/g).forEach(function (klass) {
	                        (when === undefined ? !$this.hasClass(klass) : when) ? $this.addClass(klass) : $this.removeClass(klass);
	                    });
	                });
	            },
	            scrollTop: function (value) {
	                if (!this.length) return;
	                var hasScrollTop = 'scrollTop' in this[0];
	                if (value === undefined) return hasScrollTop ? this[0].scrollTop : this[0].pageYOffset;
	                return this.each(hasScrollTop ? function () {
	                    this.scrollTop = value;
	                } : function () {
	                    this.scrollTo(this.scrollX, value);
	                });
	            },
	            scrollLeft: function (value) {
	                if (!this.length) return;
	                var hasScrollLeft = 'scrollLeft' in this[0];
	                if (value === undefined) return hasScrollLeft ? this[0].scrollLeft : this[0].pageXOffset;
	                return this.each(hasScrollLeft ? function () {
	                    this.scrollLeft = value;
	                } : function () {
	                    this.scrollTo(value, this.scrollY);
	                });
	            },
	            position: function () {
	                if (!this.length) return;
	
	                var elem = this[0],
	
	                // Get *real* offsetParent
	                offsetParent = this.offsetParent(),
	
	                // Get correct offsets
	                offset = this.offset(),
	                    parentOffset = rootNodeRE.test(offsetParent[0].nodeName) ? { top: 0, left: 0 } : offsetParent.offset();
	
	                // Subtract element margins
	                // note: when an element has margin: auto the offsetLeft and marginLeft
	                // are the same in Safari causing offset.left to incorrectly be 0
	                offset.top -= parseFloat($(elem).css('margin-top')) || 0;
	                offset.left -= parseFloat($(elem).css('margin-left')) || 0;
	
	                // Add offsetParent borders
	                parentOffset.top += parseFloat($(offsetParent[0]).css('border-top-width')) || 0;
	                parentOffset.left += parseFloat($(offsetParent[0]).css('border-left-width')) || 0;
	
	                // Subtract the two offsets
	                return {
	                    top: offset.top - parentOffset.top,
	                    left: offset.left - parentOffset.left
	                };
	            },
	            offsetParent: function () {
	                return this.map(function () {
	                    var parent = this.offsetParent || document.body;
	                    while (parent && !rootNodeRE.test(parent.nodeName) && $(parent).css("position") == "static") parent = parent.offsetParent;
	                    return parent;
	                });
	            }
	        };
	
	        // for now
	        $.fn.detach = $.fn.remove
	
	        // Generate the `width` and `height` functions
	        ;['width', 'height'].forEach(function (dimension) {
	            var dimensionProperty = dimension.replace(/./, function (m) {
	                return m[0].toUpperCase();
	            });
	
	            $.fn[dimension] = function (value) {
	                var offset,
	                    el = this[0];
	                if (value === undefined) return isWindow(el) ? el['inner' + dimensionProperty] : isDocument(el) ? el.documentElement['scroll' + dimensionProperty] : (offset = this.offset()) && offset[dimension];else return this.each(function (idx) {
	                    el = $(this);
	                    el.css(dimension, funcArg(this, value, idx, el[dimension]()));
	                });
	            };
	        });
	
	        function traverseNode(node, fun) {
	            fun(node);
	            for (var i = 0, len = node.childNodes.length; i < len; i++) traverseNode(node.childNodes[i], fun);
	        }
	
	        // Generate the `after`, `prepend`, `before`, `append`,
	        // `insertAfter`, `insertBefore`, `appendTo`, and `prependTo` methods.
	        adjacencyOperators.forEach(function (operator, operatorIndex) {
	            var inside = operatorIndex % 2; //=> prepend, append
	
	            $.fn[operator] = function () {
	                // arguments can be nodes, arrays of nodes, Zepto objects and HTML strings
	                var argType,
	                    nodes = $.map(arguments, function (arg) {
	                    var arr = [];
	                    argType = type(arg);
	                    if (argType == "array") {
	                        arg.forEach(function (el) {
	                            if (el.nodeType !== undefined) return arr.push(el);else if ($.zepto.isZ(el)) return arr = arr.concat(el.get());
	                            arr = arr.concat(zepto.fragment(el));
	                        });
	                        return arr;
	                    }
	                    return argType == "object" || arg == null ? arg : zepto.fragment(arg);
	                }),
	                    parent,
	                    copyByClone = this.length > 1;
	                if (nodes.length < 1) return this;
	
	                return this.each(function (_, target) {
	                    parent = inside ? target : target.parentNode;
	
	                    // convert all methods to a "before" operation
	                    target = operatorIndex == 0 ? target.nextSibling : operatorIndex == 1 ? target.firstChild : operatorIndex == 2 ? target : null;
	
	                    var parentInDocument = $.contains(document.documentElement, parent);
	
	                    nodes.forEach(function (node) {
	                        if (copyByClone) node = node.cloneNode(true);else if (!parent) return $(node).remove();
	
	                        parent.insertBefore(node, target);
	                        if (parentInDocument) traverseNode(node, function (el) {
	                            if (el.nodeName != null && el.nodeName.toUpperCase() === 'SCRIPT' && (!el.type || el.type === 'text/javascript') && !el.src) {
	                                var target = el.ownerDocument ? el.ownerDocument.defaultView : window;
	                                target['eval'].call(target, el.innerHTML);
	                            }
	                        });
	                    });
	                });
	            };
	
	            // after    => insertAfter
	            // prepend  => prependTo
	            // before   => insertBefore
	            // append   => appendTo
	            $.fn[inside ? operator + 'To' : 'insert' + (operatorIndex ? 'Before' : 'After')] = function (html) {
	                $(html)[operator](this);
	                return this;
	            };
	        });
	
	        zepto.Z.prototype = Z.prototype = $.fn;
	
	        // Export internal API functions in the `$.zepto` namespace
	        zepto.uniq = uniq;
	        zepto.deserializeValue = deserializeValue;
	        $.zepto = zepto;
	
	        return $;
	    }();
	
	    window.Zepto = Zepto;
	    window.$ === undefined && (window.$ = Zepto);(function ($) {
	        var _zid = 1,
	            undefined,
	            slice = Array.prototype.slice,
	            isFunction = $.isFunction,
	            isString = function (obj) {
	            return typeof obj == 'string';
	        },
	            handlers = {},
	            specialEvents = {},
	            focusinSupported = 'onfocusin' in window,
	            focus = { focus: 'focusin', blur: 'focusout' },
	            hover = { mouseenter: 'mouseover', mouseleave: 'mouseout' };
	
	        specialEvents.click = specialEvents.mousedown = specialEvents.mouseup = specialEvents.mousemove = 'MouseEvents';
	
	        function zid(element) {
	            return element._zid || (element._zid = _zid++);
	        }
	        function findHandlers(element, event, fn, selector) {
	            event = parse(event);
	            if (event.ns) var matcher = matcherFor(event.ns);
	            return (handlers[zid(element)] || []).filter(function (handler) {
	                return handler && (!event.e || handler.e == event.e) && (!event.ns || matcher.test(handler.ns)) && (!fn || zid(handler.fn) === zid(fn)) && (!selector || handler.sel == selector);
	            });
	        }
	        function parse(event) {
	            var parts = ('' + event).split('.');
	            return { e: parts[0], ns: parts.slice(1).sort().join(' ') };
	        }
	        function matcherFor(ns) {
	            return new RegExp('(?:^| )' + ns.replace(' ', ' .* ?') + '(?: |$)');
	        }
	
	        function eventCapture(handler, captureSetting) {
	            return handler.del && !focusinSupported && handler.e in focus || !!captureSetting;
	        }
	
	        function realEvent(type) {
	            return hover[type] || focusinSupported && focus[type] || type;
	        }
	
	        function add(element, events, fn, data, selector, delegator, capture) {
	            var id = zid(element),
	                set = handlers[id] || (handlers[id] = []);
	            events.split(/\s/).forEach(function (event) {
	                if (event == 'ready') return $(document).ready(fn);
	                var handler = parse(event);
	                handler.fn = fn;
	                handler.sel = selector;
	                // emulate mouseenter, mouseleave
	                if (handler.e in hover) fn = function (e) {
	                    var related = e.relatedTarget;
	                    if (!related || related !== this && !$.contains(this, related)) return handler.fn.apply(this, arguments);
	                };
	                handler.del = delegator;
	                var callback = delegator || fn;
	                handler.proxy = function (e) {
	                    e = compatible(e);
	                    if (e.isImmediatePropagationStopped()) return;
	                    e.data = data;
	                    var result = callback.apply(element, e._args == undefined ? [e] : [e].concat(e._args));
	                    if (result === false) e.preventDefault(), e.stopPropagation();
	                    return result;
	                };
	                handler.i = set.length;
	                set.push(handler);
	                if ('addEventListener' in element) element.addEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
	            });
	        }
	        function remove(element, events, fn, selector, capture) {
	            var id = zid(element);(events || '').split(/\s/).forEach(function (event) {
	                findHandlers(element, event, fn, selector).forEach(function (handler) {
	                    delete handlers[id][handler.i];
	                    if ('removeEventListener' in element) element.removeEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
	                });
	            });
	        }
	
	        $.event = { add: add, remove: remove };
	
	        $.proxy = function (fn, context) {
	            var args = 2 in arguments && slice.call(arguments, 2);
	            if (isFunction(fn)) {
	                var proxyFn = function () {
	                    return fn.apply(context, args ? args.concat(slice.call(arguments)) : arguments);
	                };
	                proxyFn._zid = zid(fn);
	                return proxyFn;
	            } else if (isString(context)) {
	                if (args) {
	                    args.unshift(fn[context], fn);
	                    return $.proxy.apply(null, args);
	                } else {
	                    return $.proxy(fn[context], fn);
	                }
	            } else {
	                throw new TypeError("expected function");
	            }
	        };
	
	        $.fn.bind = function (event, data, callback) {
	            return this.on(event, data, callback);
	        };
	        $.fn.unbind = function (event, callback) {
	            return this.off(event, callback);
	        };
	        $.fn.one = function (event, selector, data, callback) {
	            return this.on(event, selector, data, callback, 1);
	        };
	
	        var returnTrue = function () {
	            return true;
	        },
	            returnFalse = function () {
	            return false;
	        },
	            ignoreProperties = /^([A-Z]|returnValue$|layer[XY]$|webkitMovement[XY]$)/,
	            eventMethods = {
	            preventDefault: 'isDefaultPrevented',
	            stopImmediatePropagation: 'isImmediatePropagationStopped',
	            stopPropagation: 'isPropagationStopped'
	        };
	
	        function compatible(event, source) {
	            if (source || !event.isDefaultPrevented) {
	                source || (source = event);
	
	                $.each(eventMethods, function (name, predicate) {
	                    var sourceMethod = source[name];
	                    event[name] = function () {
	                        this[predicate] = returnTrue;
	                        return sourceMethod && sourceMethod.apply(source, arguments);
	                    };
	                    event[predicate] = returnFalse;
	                });
	
	                event.timeStamp || (event.timeStamp = Date.now());
	
	                if (source.defaultPrevented !== undefined ? source.defaultPrevented : 'returnValue' in source ? source.returnValue === false : source.getPreventDefault && source.getPreventDefault()) event.isDefaultPrevented = returnTrue;
	            }
	            return event;
	        }
	
	        function createProxy(event) {
	            var key,
	                proxy = { originalEvent: event };
	            for (key in event) if (!ignoreProperties.test(key) && event[key] !== undefined) proxy[key] = event[key];
	
	            return compatible(proxy, event);
	        }
	
	        $.fn.delegate = function (selector, event, callback) {
	            return this.on(event, selector, callback);
	        };
	        $.fn.undelegate = function (selector, event, callback) {
	            return this.off(event, selector, callback);
	        };
	
	        $.fn.live = function (event, callback) {
	            $(document.body).delegate(this.selector, event, callback);
	            return this;
	        };
	        $.fn.die = function (event, callback) {
	            $(document.body).undelegate(this.selector, event, callback);
	            return this;
	        };
	
	        $.fn.on = function (event, selector, data, callback, one) {
	            var autoRemove,
	                delegator,
	                $this = this;
	            if (event && !isString(event)) {
	                $.each(event, function (type, fn) {
	                    $this.on(type, selector, data, fn, one);
	                });
	                return $this;
	            }
	
	            if (!isString(selector) && !isFunction(callback) && callback !== false) callback = data, data = selector, selector = undefined;
	            if (callback === undefined || data === false) callback = data, data = undefined;
	
	            if (callback === false) callback = returnFalse;
	
	            return $this.each(function (_, element) {
	                if (one) autoRemove = function (e) {
	                    remove(element, e.type, callback);
	                    return callback.apply(this, arguments);
	                };
	
	                if (selector) delegator = function (e) {
	                    var evt,
	                        match = $(e.target).closest(selector, element).get(0);
	                    if (match && match !== element) {
	                        evt = $.extend(createProxy(e), { currentTarget: match, liveFired: element });
	                        return (autoRemove || callback).apply(match, [evt].concat(slice.call(arguments, 1)));
	                    }
	                };
	
	                add(element, event, callback, data, selector, delegator || autoRemove);
	            });
	        };
	        $.fn.off = function (event, selector, callback) {
	            var $this = this;
	            if (event && !isString(event)) {
	                $.each(event, function (type, fn) {
	                    $this.off(type, selector, fn);
	                });
	                return $this;
	            }
	
	            if (!isString(selector) && !isFunction(callback) && callback !== false) callback = selector, selector = undefined;
	
	            if (callback === false) callback = returnFalse;
	
	            return $this.each(function () {
	                remove(this, event, callback, selector);
	            });
	        };
	
	        $.fn.trigger = function (event, args) {
	            event = isString(event) || $.isPlainObject(event) ? $.Event(event) : compatible(event);
	            event._args = args;
	            return this.each(function () {
	                // handle focus(), blur() by calling them directly
	                if (event.type in focus && typeof this[event.type] == "function") this[event.type]();
	                // items in the collection might not be DOM elements
	                else if ('dispatchEvent' in this) this.dispatchEvent(event);else $(this).triggerHandler(event, args);
	            });
	        };
	
	        // triggers event handlers on current element just as if an event occurred,
	        // doesn't trigger an actual event, doesn't bubble
	        $.fn.triggerHandler = function (event, args) {
	            var e, result;
	            this.each(function (i, element) {
	                e = createProxy(isString(event) ? $.Event(event) : event);
	                e._args = args;
	                e.target = element;
	                $.each(findHandlers(element, event.type || event), function (i, handler) {
	                    result = handler.proxy(e);
	                    if (e.isImmediatePropagationStopped()) return false;
	                });
	            });
	            return result;
	        }
	
	        // shortcut methods for `.bind(event, fn)` for each event type
	        ;('focusin focusout focus blur load resize scroll unload click dblclick ' + 'mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave ' + 'change select keydown keypress keyup error').split(' ').forEach(function (event) {
	            $.fn[event] = function (callback) {
	                return 0 in arguments ? this.bind(event, callback) : this.trigger(event);
	            };
	        });
	
	        $.Event = function (type, props) {
	            if (!isString(type)) props = type, type = props.type;
	            var event = document.createEvent(specialEvents[type] || 'Events'),
	                bubbles = true;
	            if (props) for (var name in props) name == 'bubbles' ? bubbles = !!props[name] : event[name] = props[name];
	            event.initEvent(type, bubbles, true);
	            return compatible(event);
	        };
	    })(Zepto);(function ($) {
	        var jsonpID = +new Date(),
	            document = window.document,
	            key,
	            name,
	            rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
	            scriptTypeRE = /^(?:text|application)\/javascript/i,
	            xmlTypeRE = /^(?:text|application)\/xml/i,
	            jsonType = 'application/json',
	            htmlType = 'text/html',
	            blankRE = /^\s*$/,
	            originAnchor = document.createElement('a');
	
	        originAnchor.href = window.location.href;
	
	        // trigger a custom event and return false if it was cancelled
	        function triggerAndReturn(context, eventName, data) {
	            var event = $.Event(eventName);
	            $(context).trigger(event, data);
	            return !event.isDefaultPrevented();
	        }
	
	        // trigger an Ajax "global" event
	        function triggerGlobal(settings, context, eventName, data) {
	            if (settings.global) return triggerAndReturn(context || document, eventName, data);
	        }
	
	        // Number of active Ajax requests
	        $.active = 0;
	
	        function ajaxStart(settings) {
	            if (settings.global && $.active++ === 0) triggerGlobal(settings, null, 'ajaxStart');
	        }
	        function ajaxStop(settings) {
	            if (settings.global && ! --$.active) triggerGlobal(settings, null, 'ajaxStop');
	        }
	
	        // triggers an extra global event "ajaxBeforeSend" that's like "ajaxSend" but cancelable
	        function ajaxBeforeSend(xhr, settings) {
	            var context = settings.context;
	            if (settings.beforeSend.call(context, xhr, settings) === false || triggerGlobal(settings, context, 'ajaxBeforeSend', [xhr, settings]) === false) return false;
	
	            triggerGlobal(settings, context, 'ajaxSend', [xhr, settings]);
	        }
	        function ajaxSuccess(data, xhr, settings, deferred) {
	            var context = settings.context,
	                status = 'success';
	            settings.success.call(context, data, status, xhr);
	            if (deferred) deferred.resolveWith(context, [data, status, xhr]);
	            triggerGlobal(settings, context, 'ajaxSuccess', [xhr, settings, data]);
	            ajaxComplete(status, xhr, settings);
	        }
	        // type: "timeout", "error", "abort", "parsererror"
	        function ajaxError(error, type, xhr, settings, deferred) {
	            var context = settings.context;
	            settings.error.call(context, xhr, type, error);
	            if (deferred) deferred.rejectWith(context, [xhr, type, error]);
	            triggerGlobal(settings, context, 'ajaxError', [xhr, settings, error || type]);
	            ajaxComplete(type, xhr, settings);
	        }
	        // status: "success", "notmodified", "error", "timeout", "abort", "parsererror"
	        function ajaxComplete(status, xhr, settings) {
	            var context = settings.context;
	            settings.complete.call(context, xhr, status);
	            triggerGlobal(settings, context, 'ajaxComplete', [xhr, settings]);
	            ajaxStop(settings);
	        }
	
	        function ajaxDataFilter(data, type, settings) {
	            if (settings.dataFilter == empty) return data;
	            var context = settings.context;
	            return settings.dataFilter.call(context, data, type);
	        }
	
	        // Empty function, used as default callback
	        function empty() {}
	
	        $.ajaxJSONP = function (options, deferred) {
	            if (!('type' in options)) return $.ajax(options);
	
	            var _callbackName = options.jsonpCallback,
	                callbackName = ($.isFunction(_callbackName) ? _callbackName() : _callbackName) || 'Zepto' + jsonpID++,
	                script = document.createElement('script'),
	                originalCallback = window[callbackName],
	                responseData,
	                abort = function (errorType) {
	                $(script).triggerHandler('error', errorType || 'abort');
	            },
	                xhr = { abort: abort },
	                abortTimeout;
	
	            if (deferred) deferred.promise(xhr);
	
	            $(script).on('load error', function (e, errorType) {
	                clearTimeout(abortTimeout);
	                $(script).off().remove();
	
	                if (e.type == 'error' || !responseData) {
	                    ajaxError(null, errorType || 'error', xhr, options, deferred);
	                } else {
	                    ajaxSuccess(responseData[0], xhr, options, deferred);
	                }
	
	                window[callbackName] = originalCallback;
	                if (responseData && $.isFunction(originalCallback)) originalCallback(responseData[0]);
	
	                originalCallback = responseData = undefined;
	            });
	
	            if (ajaxBeforeSend(xhr, options) === false) {
	                abort('abort');
	                return xhr;
	            }
	
	            window[callbackName] = function () {
	                responseData = arguments;
	            };
	
	            script.src = options.url.replace(/\?(.+)=\?/, '?$1=' + callbackName);
	            document.head.appendChild(script);
	
	            if (options.timeout > 0) abortTimeout = setTimeout(function () {
	                abort('timeout');
	            }, options.timeout);
	
	            return xhr;
	        };
	
	        $.ajaxSettings = {
	            // Default type of request
	            type: 'GET',
	            // Callback that is executed before request
	            beforeSend: empty,
	            // Callback that is executed if the request succeeds
	            success: empty,
	            // Callback that is executed the the server drops error
	            error: empty,
	            // Callback that is executed on request complete (both: error and success)
	            complete: empty,
	            // The context for the callbacks
	            context: null,
	            // Whether to trigger "global" Ajax events
	            global: true,
	            // Transport
	            xhr: function () {
	                return new window.XMLHttpRequest();
	            },
	            // MIME types mapping
	            // IIS returns Javascript as "application/x-javascript"
	            accepts: {
	                script: 'text/javascript, application/javascript, application/x-javascript',
	                json: jsonType,
	                xml: 'application/xml, text/xml',
	                html: htmlType,
	                text: 'text/plain'
	            },
	            // Whether the request is to another domain
	            crossDomain: false,
	            // Default timeout
	            timeout: 0,
	            // Whether data should be serialized to string
	            processData: true,
	            // Whether the browser should be allowed to cache GET responses
	            cache: true,
	            //Used to handle the raw response data of XMLHttpRequest.
	            //This is a pre-filtering function to sanitize the response.
	            //The sanitized response should be returned
	            dataFilter: empty
	        };
	
	        function mimeToDataType(mime) {
	            if (mime) mime = mime.split(';', 2)[0];
	            return mime && (mime == htmlType ? 'html' : mime == jsonType ? 'json' : scriptTypeRE.test(mime) ? 'script' : xmlTypeRE.test(mime) && 'xml') || 'text';
	        }
	
	        function appendQuery(url, query) {
	            if (query == '') return url;
	            return (url + '&' + query).replace(/[&?]{1,2}/, '?');
	        }
	
	        // serialize payload and append it to the URL for GET requests
	        function serializeData(options) {
	            if (options.processData && options.data && $.type(options.data) != "string") options.data = $.param(options.data, options.traditional);
	            if (options.data && (!options.type || options.type.toUpperCase() == 'GET' || 'jsonp' == options.dataType)) options.url = appendQuery(options.url, options.data), options.data = undefined;
	        }
	
	        $.ajax = function (options) {
	            var settings = $.extend({}, options || {}),
	                deferred = $.Deferred && $.Deferred(),
	                urlAnchor,
	                hashIndex;
	            for (key in $.ajaxSettings) if (settings[key] === undefined) settings[key] = $.ajaxSettings[key];
	
	            ajaxStart(settings);
	
	            if (!settings.crossDomain) {
	                urlAnchor = document.createElement('a');
	                urlAnchor.href = settings.url;
	                // cleans up URL for .href (IE only), see https://github.com/madrobby/zepto/pull/1049
	                urlAnchor.href = urlAnchor.href;
	                settings.crossDomain = originAnchor.protocol + '//' + originAnchor.host !== urlAnchor.protocol + '//' + urlAnchor.host;
	            }
	
	            if (!settings.url) settings.url = window.location.toString();
	            if ((hashIndex = settings.url.indexOf('#')) > -1) settings.url = settings.url.slice(0, hashIndex);
	            serializeData(settings);
	
	            var dataType = settings.dataType,
	                hasPlaceholder = /\?.+=\?/.test(settings.url);
	            if (hasPlaceholder) dataType = 'jsonp';
	
	            if (settings.cache === false || (!options || options.cache !== true) && ('script' == dataType || 'jsonp' == dataType)) settings.url = appendQuery(settings.url, '_=' + Date.now());
	
	            if ('jsonp' == dataType) {
	                if (!hasPlaceholder) settings.url = appendQuery(settings.url, settings.jsonp ? settings.jsonp + '=?' : settings.jsonp === false ? '' : 'callback=?');
	                return $.ajaxJSONP(settings, deferred);
	            }
	
	            var mime = settings.accepts[dataType],
	                headers = {},
	                setHeader = function (name, value) {
	                headers[name.toLowerCase()] = [name, value];
	            },
	                protocol = /^([\w-]+:)\/\//.test(settings.url) ? RegExp.$1 : window.location.protocol,
	                xhr = settings.xhr(),
	                nativeSetHeader = xhr.setRequestHeader,
	                abortTimeout;
	
	            if (deferred) deferred.promise(xhr);
	
	            if (!settings.crossDomain) setHeader('X-Requested-With', 'XMLHttpRequest');
	            setHeader('Accept', mime || '*/*');
	            if (mime = settings.mimeType || mime) {
	                if (mime.indexOf(',') > -1) mime = mime.split(',', 2)[0];
	                xhr.overrideMimeType && xhr.overrideMimeType(mime);
	            }
	            if (settings.contentType || settings.contentType !== false && settings.data && settings.type.toUpperCase() != 'GET') setHeader('Content-Type', settings.contentType || 'application/x-www-form-urlencoded');
	
	            if (settings.headers) for (name in settings.headers) setHeader(name, settings.headers[name]);
	            xhr.setRequestHeader = setHeader;
	
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState == 4) {
	                    xhr.onreadystatechange = empty;
	                    clearTimeout(abortTimeout);
	                    var result,
	                        error = false;
	                    if (xhr.status >= 200 && xhr.status < 300 || xhr.status == 304 || xhr.status == 0 && protocol == 'file:') {
	                        dataType = dataType || mimeToDataType(settings.mimeType || xhr.getResponseHeader('content-type'));
	
	                        if (xhr.responseType == 'arraybuffer' || xhr.responseType == 'blob') result = xhr.response;else {
	                            result = xhr.responseText;
	
	                            try {
	                                // http://perfectionkills.com/global-eval-what-are-the-options/
	                                // sanitize response accordingly if data filter callback provided
	                                result = ajaxDataFilter(result, dataType, settings);
	                                if (dataType == 'script') (1, eval)(result);else if (dataType == 'xml') result = xhr.responseXML;else if (dataType == 'json') result = blankRE.test(result) ? null : $.parseJSON(result);
	                            } catch (e) {
	                                error = e;
	                            }
	
	                            if (error) return ajaxError(error, 'parsererror', xhr, settings, deferred);
	                        }
	
	                        ajaxSuccess(result, xhr, settings, deferred);
	                    } else {
	                        ajaxError(xhr.statusText || null, xhr.status ? 'error' : 'abort', xhr, settings, deferred);
	                    }
	                }
	            };
	
	            if (ajaxBeforeSend(xhr, settings) === false) {
	                xhr.abort();
	                ajaxError(null, 'abort', xhr, settings, deferred);
	                return xhr;
	            }
	
	            var async = 'async' in settings ? settings.async : true;
	            xhr.open(settings.type, settings.url, async, settings.username, settings.password);
	
	            if (settings.xhrFields) for (name in settings.xhrFields) xhr[name] = settings.xhrFields[name];
	
	            for (name in headers) nativeSetHeader.apply(xhr, headers[name]);
	
	            if (settings.timeout > 0) abortTimeout = setTimeout(function () {
	                xhr.onreadystatechange = empty;
	                xhr.abort();
	                ajaxError(null, 'timeout', xhr, settings, deferred);
	            }, settings.timeout);
	
	            // avoid sending empty string (#319)
	            xhr.send(settings.data ? settings.data : null);
	            return xhr;
	        };
	
	        // handle optional data/success arguments
	        function parseArguments(url, data, success, dataType) {
	            if ($.isFunction(data)) dataType = success, success = data, data = undefined;
	            if (!$.isFunction(success)) dataType = success, success = undefined;
	            return {
	                url: url,
	                data: data,
	                success: success,
	                dataType: dataType
	            };
	        }
	
	        $.get = function () /* url, data, success, dataType */{
	            return $.ajax(parseArguments.apply(null, arguments));
	        };
	
	        $.post = function () /* url, data, success, dataType */{
	            var options = parseArguments.apply(null, arguments);
	            options.type = 'POST';
	            return $.ajax(options);
	        };
	
	        $.getJSON = function () /* url, data, success */{
	            var options = parseArguments.apply(null, arguments);
	            options.dataType = 'json';
	            return $.ajax(options);
	        };
	
	        $.fn.load = function (url, data, success) {
	            if (!this.length) return this;
	            var self = this,
	                parts = url.split(/\s/),
	                selector,
	                options = parseArguments(url, data, success),
	                callback = options.success;
	            if (parts.length > 1) options.url = parts[0], selector = parts[1];
	            options.success = function (response) {
	                self.html(selector ? $('<div>').html(response.replace(rscript, "")).find(selector) : response);
	                callback && callback.apply(self, arguments);
	            };
	            $.ajax(options);
	            return this;
	        };
	
	        var escape = encodeURIComponent;
	
	        function serialize(params, obj, traditional, scope) {
	            var type,
	                array = $.isArray(obj),
	                hash = $.isPlainObject(obj);
	            $.each(obj, function (key, value) {
	                type = $.type(value);
	                if (scope) key = traditional ? scope : scope + '[' + (hash || type == 'object' || type == 'array' ? key : '') + ']';
	                // handle data in serializeArray() format
	                if (!scope && array) params.add(value.name, value.value);
	                // recurse into nested objects
	                else if (type == "array" || !traditional && type == "object") serialize(params, value, traditional, key);else params.add(key, value);
	            });
	        }
	
	        $.param = function (obj, traditional) {
	            var params = [];
	            params.add = function (key, value) {
	                if ($.isFunction(value)) value = value();
	                if (value == null) value = "";
	                this.push(escape(key) + '=' + escape(value));
	            };
	            serialize(params, obj, traditional);
	            return params.join('&').replace(/%20/g, '+');
	        };
	    })(Zepto);(function ($) {
	        $.fn.serializeArray = function () {
	            var name,
	                type,
	                result = [],
	                add = function (value) {
	                if (value.forEach) return value.forEach(add);
	                result.push({ name: name, value: value });
	            };
	            if (this[0]) $.each(this[0].elements, function (_, field) {
	                type = field.type, name = field.name;
	                if (name && field.nodeName.toLowerCase() != 'fieldset' && !field.disabled && type != 'submit' && type != 'reset' && type != 'button' && type != 'file' && (type != 'radio' && type != 'checkbox' || field.checked)) add($(field).val());
	            });
	            return result;
	        };
	
	        $.fn.serialize = function () {
	            var result = [];
	            this.serializeArray().forEach(function (elm) {
	                result.push(encodeURIComponent(elm.name) + '=' + encodeURIComponent(elm.value));
	            });
	            return result.join('&');
	        };
	
	        $.fn.submit = function (callback) {
	            if (0 in arguments) this.bind('submit', callback);else if (this.length) {
	                var event = $.Event('submit');
	                this.eq(0).trigger(event);
	                if (!event.isDefaultPrevented()) this.get(0).submit();
	            }
	            return this;
	        };
	    })(Zepto);(function () {
	        // getComputedStyle shouldn't freak out when called
	        // without a valid element as argument
	        try {
	            getComputedStyle(undefined);
	        } catch (e) {
	            var nativeGetComputedStyle = getComputedStyle;
	            window.getComputedStyle = function (element, pseudoElement) {
	                try {
	                    return nativeGetComputedStyle(element, pseudoElement);
	                } catch (e) {
	                    return null;
	                }
	            };
	        }
	    })();
	    return Zepto;
	});

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(4);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept(4, function() {
				var newContent = __webpack_require__(4);
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports
	
	
	// module
	exports.push([module.id, "body{background:#fff;font-family:latolight,sans-serif;color:#707473;font-size:14px;line-height:1.4em;transition:all .4s ease-in-out}.flex{display:flex}html{overflow-x:hidden;overflow-y:auto}li{list-style:none;padding:0;margin:0}.text-center{text-align:center}.text-left{text-align:left}a{text-decoration:none;outline:0}.col a,a{color:#707473}.col p{margin-bottom:5px}.col{float:left}.clear{clear:both;display:block;overflow:hidden;visibility:hidden;width:0;height:0}.bar-icon{width:80px;height:88px;float:left}.bar-title{float:left;width:700px;padding-top:10px}.bar-title .title,.bar-title h1{font-size:33px;color:#444e69;text-shadow:0 1px 1px #f2f2f2;line-height:33px;margin:0 0 4px;display:block}.tel{width:100px;height:100px;padding-left:15px;text-align:center;vertical-align:middle;position:relative;margin:10px;*float:left;display:table-cell}.bar-title .title span,.bar-title h1 span{color:#2e88c7}.sub-text{color:#6a7184;font-size:16px}.bar-right{width:460px;float:right}.footer a{color:#7a7474}.footer a:hover{color:#60aff6}.gotoTop{background:url(" + __webpack_require__(6) + ") no-repeat scroll -135px -249px #666;border-radius:4px 4px 4px 4px;display:block;float:left;height:50px;outline:0 none;text-indent:-9999em;width:50px;position:absolute;text-align:center;right:-51px;bottom:10px;_position:absolute!important;right:30px;bottom:80px}.gotoTopHover,.gotoTopTip{background-color:#333}.gotoTopTip{bottom:80px;height:25px;margin-top:-20px;position:fixed;right:20px;display:none;color:#fff}*{margin:0;padding:0;list-style-type:none}a,img{border:0}body{min-width:auto!important;overflow-x:hidden}.right{float:right}.left{float:left}*,.button{outline:none}*{-webkit-appearance:none;appearance:none}h1{font-size:25px;font-weight:500}@media screen and (max-width:413px){h1{font-size:1rem}}@media screen and (max-width:374px){h1{font-size:.8rem}}h2{font-size:25px;font-weight:500}@media screen and (min-width:375px) and (max-width:413px){h2{font-size:.8rem}}@media screen and (max-width:374px){h2{font-size:.5rem}}h3{font-size:20px;font-weight:500}@media screen and (min-width:375px) and (max-width:768px){h3{font-size:1.1rem}}@media screen and (max-width:374px){h3{font-size:.8rem}}h1{font-size:1.2rem}h2{font-size:1rem}h3{font-size:1.2rem}h4{font-size:.9rem;font-weight:lighter}.nav-menu-rotate{animation:nav-menu-rotate .6s;-webkit-animation:nav-menu-rotate .6s;animation-fill-mode:forwards;-webkit-animation-fill-mode:forwards}.nav-menu-rotate,.nav-menu-rotate-back{transform-origin:center center;-webkit-transform-origin:center center}.nav-menu-rotate-back{animation:nav-menu-rotate-back .6s;-webkit-animation:nav-menu-rotate-back .6s;animation-fill-mode:forwards;-webkit-animation-fill-mode:forwards}.arrow-vertical{animation:arrow-rotate .3s;-webkit-animation:arrow-rotate .3s;animation-fill-mode:forwards;-webkit-animation-fill-mode:forwards}.arrow-vertical,.arrow-vertical-back{transform-origin:center center;-webkit-transform-origin:center center}.arrow-vertical-back{animation:arrow-rotate-back .3s;-webkit-animation:arrow-rotate-back .3s;animation-fill-mode:forwards;-webkit-animation-fill-mode:forwards}header{font-size:100%;width:100%;line-height:3.3rem;height:2.8rem;vertical-align:middle;font-family:latolight,sans-serif}header a{color:#616264}header .navication{background:#303030;height:2.8rem;width:100%;margin:0;display:flex;flex-flow:row wrap;justify-content:space-between;position:fixed;top:0;z-index:9999}header .navication .logo{float:left;width:107px;position:relative;max-height:60px;top:3px;margin-left:10px}header .navication .logo img{width:100%}header .navication #navbar-toggle{position:absolute;width:100%;color:#707473;left:0}header .navication #navbar-toggle button{display:block;width:40px;height:40px;font-size:30px;position:absolute;text-align:center;color:#fff;right:0;top:0;z-index:888;background:none;border:none}header .navication #navbar-toggle button span{width:20px;height:2px;background:#fff;display:block;margin:4px auto 0;transition:all .6s}header .navication #navbar-toggle button.close span:nth-child(1){transform:matrix(.707107,.707107,-.707107,.707107,0,6);transition:all .6s}header .navication #navbar-toggle button.close span:nth-child(2){opacity:0;transition:all .6s}header .navication #navbar-toggle button.close span:nth-child(3){transform:matrix(.707107,-.707107,.707107,.707107,0,-6);transition:all .6s}header .navication #navbar-toggle button i{transform:rotate(45deg);display:none;font-weight:lighter;font-size:35px;border-radius:100%}header .language_nav,header .moble-nav{display:block;max-height:3000px;height:auto;overflow:hidden;box-shadow:#000;overflow-x:hidden;overflow-y:auto;position:fixed;width:100%;top:2.83rem;opacity:0;z-index:-1;transform:translateY(-20px);background:hsla(0,0%,100%,.4);-webkit-box-shadow:0 2px 10px rgba(0,0,0,.1);-moz-box-shadow:0 2px 10px rgba(0,0,0,.1);transition:all .4s linear}header .language_nav.active,header .moble-nav.active{opacity:1;z-index:999;transform:translateY(0);transition:all .4s linear}header .language_nav.active.language_active,header .moble-nav.active.language_active{transform:translateY(-213px);transition:all .4s linear}header .language_nav .nav-menu,header .moble-nav .nav-menu{display:block;width:100%;background:#fff;border-bottom:1px solid #ececec;padding-left:13px}header .language_nav .nav-menu .nav-menu-li,header .moble-nav .nav-menu .nav-menu-li{overflow:hidden;width:100%;opacity:0;background:#fff;transform:translateX(100%);max-height:0;transition:all .8s}header .language_nav .nav-menu .nav-menu-li.active,header .moble-nav .nav-menu .nav-menu-li.active{opacity:1;z-index:5;max-height:3000px!important;transform:translateX(0);transition:all .9s}header .language_nav .nav-menu .nav-menu-li .nav-menu-content,header .moble-nav .nav-menu .nav-menu-li .nav-menu-content{width:100%}header .language_nav .nav-menu .nav-menu-li .nav-menu-content:after,header .moble-nav .nav-menu .nav-menu-li .nav-menu-content:after{clear:both;content:\"\";display:block}header .language_nav .nav-menu .nav-menu-li .nav-menu-content a,header .moble-nav .nav-menu .nav-menu-li .nav-menu-content a{padding:0 20px;color:#616264;border-top:1px solid #ececec;display:block}header .language_nav .nav-menu .nav-menu-li .nav-menu-content a:hover,header .moble-nav .nav-menu .nav-menu-li .nav-menu-content a:hover{color:#60aff6}header .language_nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list,header .moble-nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list{color:#000;float:none;width:100%}header .language_nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list dl,header .moble-nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list dl{line-height:30px}header .language_nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list dl dt,header .moble-nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list dl dt{display:none;line-height:40px;padding-left:20px}header .language_nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list dl dt a,header .moble-nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list dl dt a{padding:0}header .language_nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list dl dt.nav-product-list-title,header .moble-nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list dl dt.nav-product-list-title{display:block;border-top:1px solid #ececec;border-bottom:0;color:#707473;padding-left:10px;margin-bottom:0}header .language_nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list:nth-child(7),header .moble-nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list:nth-child(7){margin-right:0}header .language_nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list .nav-product-list-title,header .moble-nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list .nav-product-list-title{padding:10px 0;border-bottom:1px solid #b7b8b9;margin-bottom:10px;color:#616264}header .language_nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list:last-child dl dt.nav-product-list-title,header .moble-nav .nav-menu .nav-menu-li .nav-menu-content .nav-product-list:last-child dl dt.nav-product-list-title{border-bottom:0}header .language_nav .nav-menu .nav-menu-li.nav-product li,header .moble-nav .nav-menu .nav-menu-li.nav-product li{display:inline-block;padding:10px;width:126px}@media screen and (max-width:413px){header .language_nav .nav-menu .nav-menu-li.nav-product li,header .moble-nav .nav-menu .nav-menu-li.nav-product li{width:45%}}header .language_nav .nav-menu .nav-menu-li.nav-product li div,header .moble-nav .nav-menu .nav-menu-li.nav-product li div{display:block;width:100%}header .language_nav .nav-menu .nav-menu-li.nav-product li div img,header .moble-nav .nav-menu .nav-menu-li.nav-product li div img{width:100%}header .language_nav .nav-menu .nav-menu-li.nav-product li div:after,header .moble-nav .nav-menu .nav-menu-li.nav-product li div:after{width:100%;height:1px;background:#b7b8b9;content:\"\";display:block}header .language_nav .nav-menu .nav-menu-li.nav-product li a,header .moble-nav .nav-menu .nav-menu-li.nav-product li a{color:#616264}header .language_nav .nav-menu .nav-menu-li.nav-product li a img,header .moble-nav .nav-menu .nav-menu-li.nav-product li a img{width:100%}header .language_nav .nav-menu .nav-menu-li.nav-product li a .nav-menu-scale,header .moble-nav .nav-menu .nav-menu-li.nav-product li a .nav-menu-scale{animation:nav-menu-scale 1.5s;-webkit-animation:nav-menu-scale 1.5s;-moz-animation:nav-menu-scale 1.5s;-ms-animation:nav-menu-scale 1.5s;animation-fill-mode:forwards;-webkit-animation-fill-mode:forwards}header .language_nav .nav-menu .nav-menu-li.nav-product li a .nav-menu-scale-back,header .moble-nav .nav-menu .nav-menu-li.nav-product li a .nav-menu-scale-back{animation:nav-menu-scale-back 1.5s;-webkit-animation:nav-menu-scale-back 1.5s;-moz-animation:nav-menu-scale-back 1.5s;-ms-animation:nav-menu-scale-back 1.5s;animation-fill-mode:forwards;-webkit-animation-fill-mode:forwards}header .language_nav .nav-menu .nav-menu-icon,header .moble-nav .nav-menu .nav-menu-icon{font-style:inherit;float:right;margin-right:29px;display:block;line-height:52px}header .language_nav .nav-menu a,header .moble-nav .nav-menu a{color:#707473}header .language_nav .nav-menu:nth-child(2) li a:first-child,header .moble-nav .nav-menu:nth-child(2) li a:first-child{margin-left:0}header .language_nav a,header .moble-nav a{color:#707473}header .language_nav .language,header .moble-nav .language{background:linear-gradient(top,#fff,#f2f2f2);background:-webkit-linear-gradient(top,#fff,#f2f2f2);background:-moz-linear-gradient(top,#fff,#f2f2f2)}header .language_nav .language .title,header .moble-nav .language .title{display:flex;flex-flow:row;justify-content:center;align-items:center}header .language_nav .language .title span,header .moble-nav .language .title span{background:url(" + __webpack_require__(7) + ") no-repeat 0;padding-left:23px;padding-right:10px;box-sizing:border-box;background-size:1.3rem}header .language_nav{transform-origin:top;transform:scaleY(0)}header .language_nav.active{transform:scaleY(1);transition:all .4s linear}.mask{overflow:hidden;height:100%;width:100%}.footer{width:100%;padding:22px 0 20px;font-size:12px;background:#505050;color:#b0b0b0}.footer:after{clear:both;content:\"\";display:block}.footer a{color:#b0b0b0}@media screen and (max-width:768px){.info-links{width:100%;display:block;margin-top:15px;text-align:left}.footer-content{width:100%;line-height:25px}}@media screen and (max-width:768px){.electronic-title-top{margin-top:60px}}.electronic-title{background:#f7f8f9;width:100%;line-height:45px;box-sizing:border-box;padding:2rem 1%;color:#707473}.electronic-title h1{color:#707473;font-weight:300;font-size:35px;line-height:40px;font-weight:lighter;font-family:latoregular,sans-serif}.electronic-title a{color:#707473}ul.social-icons{margin:0;padding:0;width:auto;margin-top:-4px}ul.social-icons li{background-image:url(" + __webpack_require__(8) + ");background-repeat:no-repeat;background-color:#fff;background-position:0 100px;display:inline-block;margin:-1px 1px 5px 0;padding:0;border-radius:100%;overflow:visible;transition:all .3s ease;box-shadow:0 2px 2px 0 rgba(0,0,0,.3);-moz-border-radius:100%;-moz-transition:all .3s ease;-ms-transition:all .3s ease;-o-transition:all .3s ease;-webkit-border-radius:100%;-webkit-transition:all .3s ease}ul.social-icons li a{display:block;height:30px;width:30px;text-align:center}ul.social-icons li[class] a{text-indent:-9999px}ul.social-icons li a:hover{text-decoration:none}ul.social-icons li a i[class^=fa-]{color:#444;font-size:16px;position:relative;top:3px}ul.social-icons li a:active{box-shadow:inset 0 0 10px rgba(0,0,0,.3),inset 0 0 10px rgba(0,0,0,.3);-moz-box-shadow:inset 0 0 10px rgba(0,0,0,.3),inset 0 0 10px rgba(0,0,0,.3);-webkit-box-shadow:inset 0 0 10px rgba(0,0,0,.3),inset 0 0 10px rgba(0,0,0,.3)}ul.social-icons li:active,ul.social-icons li a:active{border-radius:100%;-moz-border-radius:100%;-webkit-border-radius:100%}ul.social-icons li.digg{background-position:0 0}ul.social-icons li.digg:hover{background-position:0 -30px}ul.social-icons li.dribbble{background-position:0 -60px}ul.social-icons li.dribbble:hover{background-position:0 -90px}ul.social-icons li.facebook{background-position:0 -120px}ul.social-icons li.facebook:hover{background-position:0 -150px}ul.social-icons li.flickr{background-position:0 -180px}ul.social-icons li.flickr:hover{background-position:0 -210px}ul.social-icons li.forrst{background-position:0 -240px}ul.social-icons li.forrst:hover{background-position:0 -270px}ul.social-icons li.html5{background-position:0 -360px}ul.social-icons li.html5:hover{background-position:0 -390px}ul.social-icons li.icloud{background-position:0 -420px}ul.social-icons li.icloud:hover{background-position:0 -450px}ul.social-icons li.lastfm{background-position:0 -480px}ul.social-icons li.lastfm:hover{background-position:0 -510px}ul.social-icons li.linkedin{background-position:0 -540px}ul.social-icons li.linkedin:hover{background-position:0 -570px}ul.social-icons li.myspace{background-position:0 -600px}ul.social-icons li.myspace:hover{background-position:0 -630px}ul.social-icons li.paypal{background-position:0 -660px}ul.social-icons li.paypal:hover{background-position:0 -690px}ul.social-icons li.picasa{background-position:0 -720px}ul.social-icons li.picasa:hover{background-position:0 -750px}ul.social-icons li.pinterest{background-position:0 -780px}ul.social-icons li.pinterest:hover{background-position:0 -810px}ul.social-icons li.reddit{background-position:0 -840px}ul.social-icons li.reddit:hover{background-position:0 -870px}ul.social-icons li.rss{background-position:0 -900px}ul.social-icons li.rss:hover{background-position:0 -930px}ul.social-icons li.skype{background-position:0 -960px}ul.social-icons li.skype:hover{background-position:0 -990px}ul.social-icons li.stumbleupon{background-position:0 -1020px}ul.social-icons li.stumbleupon:hover{background-position:0 -1050px}ul.social-icons li.tumblr{background-position:0 -1080px}ul.social-icons li.tumblr:hover{background-position:0 -1110px}ul.social-icons li.twitter{background-position:0 -1140px}ul.social-icons li.twitter:hover{background-position:0 -1170px}ul.social-icons li.vimeo{background-position:0 -1200px}ul.social-icons li.vimeo:hover{background-position:0 -1230px}ul.social-icons li.wordpress{background-position:0 -1260px}ul.social-icons li.wordpress:hover{background-position:0 -1290px}ul.social-icons li.yahoo{background-position:0 -1320px}ul.social-icons li.yahoo:hover{background-position:0 -1350px}ul.social-icons li.youtube{background-position:0 -1380px}ul.social-icons li.youtube:hover{background-position:0 -1410px}ul.social-icons li.github{background-position:0 -1440px}ul.social-icons li.github:hover{background-position:0 -1470px}ul.social-icons li.behance{background-position:0 -1500px}ul.social-icons li.behance:hover{background-position:0 -1530px}ul.social-icons li.yelp{background-position:0 -1560px}ul.social-icons li.yelp:hover{background-position:0 -1590px}ul.social-icons li.mail{background-position:0 -1620px}ul.social-icons li.mail:hover{background-position:0 -1650px}ul.social-icons li.instagram{background-position:0 -1680px}ul.social-icons li.instagram:hover{background-position:0 -1710px}ul.social-icons li.foursquare{background-position:0 -1740px}ul.social-icons li.foursquare:hover{background-position:0 -1770px}ul.social-icons li.global{background-position:0 -1800px}ul.social-icons li.global:hover{background-position:0 -1830px}ul.social-icons li.vk{background-position:0 -1860px}ul.social-icons li.vk:hover{background-position:0 -1890px}ul.social-icons li.weibo{background-position:0 -1950px}ul.social-icons li.weibo:hover{background-position:0 -1980px}ul.social-icons li.youku{background-position:0 -2010px}ul.social-icons li.youku:hover{background-position:0 -2040px}ul.social-icons li.googleplus{background-position:0 -300px}ul.social-icons li.googleplus:hover{background-position:0 -330px}.dn{display:none}.go-top{position:fixed;right:20px;bottom:40px;z-index:999;width:46px}.go-top a{display:block;margin-bottom:10px;width:46px;height:46px;background-image:url(" + __webpack_require__(9) + ")}.go-top a:last-child{margin-bottom:0}.go-top .go{background-position:0 -150px}.go-top .go:hover{background-position:0 -250px}.go-top .feedback{background-position:0 -100px}.go-top .feedback:hover{background-position:0 -300px}.go-top .uc-2vm{background-position:0 0}.go-top .uc-2vm:hover{background-position:0 -350px}.go-top .share:hover{background-position:0 -200px}.go-top .uc-2vm-pop{position:absolute;top:-100px;right:60px;width:240px;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,.1)}.go-top .uc-2vm-pop .title-2wm{margin:10px 20px;font-size:14px}.go-top .uc-2vm-pop .logo-2wm-box{position:relative}.btn-small .qq img{width:25px;height:30px;text-align:center;vertical-align:middle;position:relative;*float:left;padding-right:5px}.btn{display:inline-block;*zoom:1;*display:inline;width:158px;height:38px;padding:0;margin:0;border:1px solid #b0b0b0;font-size:14px;line-height:38px;text-align:center;color:#b0b0b0;cursor:pointer;-webkit-transition:all .4s;transition:all .4s}.btn:hover{text-decoration:none;color:#b0b0b0}.btn:focus{outline:0}.btn:active{-webkit-box-shadow:inset 0 2px 4px rgba(0,0,0,.18);box-shadow:inset 0 2px 4px rgba(0,0,0,.18)}.btn[disabled]{border-style:dashed!important;border-color:#e0e0e0;background-color:#fff!important}.btn-disabled,.btn[disabled]{color:#b0b0b0!important;cursor:default!important}.btn-disabled{background:#e0e0e0!important;border-color:#e0e0e0!important}.btn-small{width:128px;height:30px;font-size:12px;line-height:30px}.btn-line-primary{border-color:#ff6700;background:#fff;color:#ff6700}.btn-line-primary:hover{color:#fff;background-color:#f25807;border-color:#f25807}.body-content{position:relative;margin-top:50px}.product-nav{width:100%;background:#e5e5e5;border-bottom:1px solid #ccc;height:50px;line-height:50px;z-index:10;display:block;position:fixed;top:2.8rem}.product-nav-top{margin-top:51px}.fixedNav{position:fixed;top:0}.product-nav .airwheel-E3-function-center div{display:inline-block;width:49.5%;box-sizing:border-box}.product-nav .airwheel-E3-function-center div:last-child{text-align:right}.product-nav .airwheel-E3-function-center div:last-child a{display:inline-block;padding:0 5px;text-align:center;height:30px;line-height:30px;margin-right:10px;color:#000}.product-nav .airwheel-E3-function-center div:last-child a:last-child{padding:0 15px;line-height:30px;border-radius:5px;margin-right:0;background:red;color:#fff}.product-nav .airwheel-E3-function-center div:last-child .hover{border-bottom:2px solid red}.product-nav .airwheel-E3-function-center div:last-child a:after{height:2px;width:100%;background:red;content:\"\";display:block;opacity:0;transition:opacity 2s;-webkit-transition:opacity 2s}.product-nav .airwheel-E3-function-center div:last-child a:hover:after{transition:opacity 2s;-webkit-transition:opacity 2s;opacity:1}@media screen and (max-width:768px){.product-nav{font-size:.8rem}.product-nav .airwheel-E3-function-center{width:96%;margin:0 2%}.product-nav .airwheel-E3-function-center div{display:inline-block;box-sizing:border-box}.product-nav .airwheel-E3-function-center div:first-child{display:none;text-align:right;float:right;width:100px}.product-nav .airwheel-E3-function-center div:first-child span{padding:5px 10px;background:#3db1fa;color:#fff}.product-nav .airwheel-E3-function-center div:last-child{float:none;text-align:left;width:100%}.product-nav .airwheel-E3-function-center div:last-child a{color:#000}.product-nav .airwheel-E3-function-center div:last-child a:last-child{background:#00a7ea;float:right;margin-top:10px}.product-nav .airwheel-E3-function-center div:last-child .hover{border-bottom:2px solid #00a7ea;color:#00a7ea}.product-nav .airwheel-E3-function-center div:last-child a:hover{border-bottom:2px solid #00a7ea}.product-nav .airwheel-E3-function-center div:last-child a:active{border-bottom:2px solid #00a7ea;color:#00a7ea}.product-nav .airwheel-E3-function-center div:last-child a:after{background:none}.product-nav .airwheel-E3-function-center div:last-child:after{clear:both;content:\"\"}}@media screen and (max-width:320px){.product-nav .airwheel-E3-function-center{width:98%;margin:0 1%}.product-nav .airwheel-E3-function-center div:last-child{width:100%}.product-nav .airwheel-E3-function-center div:last-child a{padding:0 2px}}.product-style h1{font-size:20px;font-weight:500}.product-style p{font-size:14px;line-height:30px;opacity:.8}.product-style p:before{display:block;background:#7f7f7f;height:1px;width:40px;margin:15px 0;content:\"\"}@media screen and (max-width:768px){.product-style h1{font-size:1.1rem}.product-style p{font-size:.8rem;line-height:25px}.product-style p:before{display:block;background:#7f7f7f;height:1px;width:40px;margin:10px 0;content:\"\"}}.main-margin-top{margin-top:80px}.main-margin-bottom-4{margin-bottom:120px}@media (max-width:414px){.main-margin-top{margin-top:40px}.main-margin-bottom-4{margin-bottom:80px}}@keyframes img-translateY{0%{transform:translateY(0)}to{transform:translateY(-10px)}}@-webkit-keyframes img-translateY{0%{transform:translateY(0)}to{transform:translateY(-10px)}}@keyframes img-translateY-back{0%{transform:translateY(-10px)}to{transform:translateY(0)}}@-webkit-keyframes img-translateY-back{0%{transform:translateY(-10px)}to{transform:translateY(0)}}@keyframes airwheel-translate{0%{opacity:0;transform:translate(-100px)}to{opacity:1;transform:translate(0)}}@keyframes arrow-rotate{0%{transform:rotate(0deg)}to{transform:rotate(90deg)}}@-webkit-keyframes arrow-rotate{0%{transform:rotate(0deg)}to{transform:rotate(90deg)}}@keyframes arrow-rotate-back{0%{transform:rotate(90deg)}to{transform:rotate(0deg)}}@-webkit-keyframes arrow-rotate-back{0%{transform:rotate(90deg)}to{transform:rotate(0deg)}}@keyframes nav-menu-rotate{0%{transform:rotate(0deg)}to{transform:rotate(90deg)}}@-webkit-keyframes nav-menu-rotate{0%{transform:rotate(0deg)}to{transform:rotate(90deg)}}@keyframes nav-menu-rotate-back{0%{transform:rotate(90deg)}to{transform:rotate(0deg)}}@-webkit-keyframes nav-menu-rotate-back{0%{transform:rotate(90deg)}to{transform:rotate(0deg)}}@keyframes airwheel_z5_fold{0%{background-position:0 0}to{background-position:150% 0}}@keyframes nav-menu-scale{0%{transform:scale(1)}to{transform:scale(1.05)}}@-webkit-keyframes nav-menu-scale{0%{transform:scale(1)}to{transform:scale(1.05)}}@keyframes nav-menu-scale-back{0%{transform:scale(1.05)}to{transform:scale(1)}}@-webkit-keyframes nav-menu-scale-back{0%{transform:scale(1.05)}to{transform:scale(1)}}#page{background:#fff;line-height:30px;margin:20px 0;text-align:center}@media (max-width:768px){#page{width:98%;margin-left:2%}}#page a,#page span{display:block;float:left;margin:0;padding:5px 20px;font-size:1rem;border:1px solid #ccc;border-left:0}#page a:nth-child(1),#page span:nth-child(1){border-top-left-radius:5px;border-bottom-left-radius:5px;border:1px solid #ccc}@media (max-width:768px){#page a,#page span{width:32.9%;padding:5px 0}}#page span:nth-child(2){background:#f8f8f8}#page span:nth-child(2):hover{border-left:0}#page span:hover{border-color:#ccc}#page span:hover:nth-child(1){border-color:#ccc;background:#f2f8ff;color:#60aff6;cursor:pointer}@media (max-width:768px){#page span:nth-child(2){display:none}}#page a:hover{background:#f2f8ff;border-color:#ccc;border-left:0}#page a:last-child{border-top-right-radius:5px;border-bottom-right-radius:5px;border:1px solid #ccc;border-left:0}@media (max-width:768px){#page a:nth-child(n+1):nth-child(-n+11){display:none}}.footer-copyright{background:#f2f2f2;width:90%;margin-top:.2rem;padding:1rem 5%;font-size:.6rem}.footer-copyright,.footer-copyright a{color:rgba(0,0,0,.7)}.footer-copyright .global{line-height:1.3rem;background:url(" + __webpack_require__(7) + ") no-repeat 0;background-size:1rem;padding:1.2rem}.footer-menu{background:#f2f2f2;width:100%}.footer-menu .foot-nav{width:90%;margin:0 5%}.footer-menu .foot-nav .flex{flex-flow:row;justify-content:space-between}.footer-menu .foot-nav .menu-toggle{border-bottom:1px solid #e5e5e5;line-height:2rem;padding-bottom:.2rem;padding-top:1rem}.footer-menu .foot-nav .menu-toggle:last-child{border-bottom:none}.footer-menu .foot-nav .menu-toggle .nav-menu-icon{font-style:inherit;line-height:32px}.footer-menu .foot-nav .menu-toggle .nav-menu-li{max-height:0;overflow:hidden;opacity:0;box-sizing:border-box;padding-left:1rem;transform:translateX(100%);transition:all .8s}.footer-menu .foot-nav .menu-toggle .nav-menu-li.active{z-index:5;opacity:1;max-height:3000px!important;transform:translateX(0);transition:all .9s}.footer-menu .foot-nav .menu-toggle .nav-menu-li a{color:rgba(0,0,0,.6)}.footer-menu .foot-nav .switch{text-align:center;line-height:3rem}.pages{margin:1rem auto;text-align:center}.pages span{border-radius:.2rem;padding:.2rem .5em;background:#707473;color:#fff}.pages a{padding:.2rem .5rem}.content-center{width:96%;margin:0 2%}@media (min-width:768px){.content-center{width:1200px;margin:0 auto}}.relative{position:relative}.absolute{position:absolute}.foot_top{border-radius:100%;color:#fff;background:rgba(0,0,0,.6);width:2rem;height:2rem;text-align:center;line-height:1.9rem;position:fixed;bottom:2rem;right:.5rem;z-index:100;display:none}.cp_icon img{width:100%;display:block}", ""]);
	
	// exports


/***/ },
/* 5 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function () {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for (var i = 0; i < this.length; i++) {
				var item = this[i];
				if (item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function (modules, mediaQuery) {
			if (typeof modules === "string") modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for (var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if (typeof id === "number") alreadyImportedModules[id] = true;
			}
			for (i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if (mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if (mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./image/42a2b8c5494842875203742abc91fc7f.png";

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAEFCu8CAAAACXBIWXMAAAsSAAALEgHS3X78AAAFy0lEQVRIS82WfUzVVRjHuW/A5RpRkxFIpEvnNGutIlZzpmNl4hTKutkbBPK6ylbELNKGS6c0i5omcHkrJiUMHV6ImiunGzVfWm3aRi2lsIRYxoz3ywVun+f0+/363Tv4o/8627nP83yf1/Occ37nhoXNNjwezybBKysrA3ZhpqenK6qqqh6BzVEA42bm6sLCwmc0WSP4vCcs5ucVBHBSqFV+bDZbE4Bfaerq6q7DrEJ4wAFDobQMI4YmU1eySo/ldFJSUpSGh1VXV6dQY5cuz01lSYR9RSzq6+tj4b3C22E6oAMRERH1Avh8vh+tVutmFUq8FKMNjB/T8LN6P6TaNwOBQDLTgbLVYrH0Wu12+3IUbyHUFBUVbYCeI9pfNO5xa15eXjeABQ9PTU1NIrQYRYyENsKacnZgsN4oQmMkgwQKxVXRRF2kFdqpG7S0tNjo5J0afpXm7RJe72yAOi2asowWeKj/EPLk4OBgD1Q2vgCb+eBHSFJglIrwCw7llLmtoKDAiWGbBJJBlgzZP7bJy5JfA9plONL05JycnD+IqMo1D4LVECwWLJ4E45GRkYuUo5Qp2wd4P0bp8D7gGfhxMowy94KlIn9BV63SaCMjwEY9C0YvYZSDQQL0DNU0ZWdn/47eQpKgav6zELSPtbW1K/x+/4VZonjJlG7G1X2Rwfo6p6amvo2KipqP+LGsmy7HcpeWUnKv7HNjY6PL7CyH8W0UAwLCB11S5F7BqWaxOOuOKiMNKCFqOYom+EpzVBqTwh4+SzVt2Bwk0FHRy+V5EePDdPVdAZAr2PBSsDsQr7Lmdjb+ekpfIXo9qzRnC5GyBJTBYW7Mzc39TpeFEmwL5IAZsxM5HuMMItU5HI7N0dHRP5gNNN6Ofg/8al1nJ9sZ6r9IKfcISJnFGN0OuwDdNahszzn04vhvqeHh4c/zUZAsTaKgAidGzwmvyVaaEyd8Q0PDTdiqzlo52L8SOYJ1XCPTQrBXlYc2wHdzwPuhhycmJq4ALxWVOjkowlFMs9aFdPAT+O+BbyX7INTBN/TDycnJh0jQRvd/MhwB5CbYcPDBT6KYRF7MydkEXYOTLGUnTmXiZDgKI84QiZ7A3u2Xps3MzPThXIuDvANBI+iQhyp1mU4nkVkO+YNM4ROgAYL3wV8m+HG20iv9miuGjs+akCBWkuyFFmNopeIRgn+GvBJaxPE9AbWxM+3o/eCraIMcdRf4NHI5q9uhrT6oBuM2CiqJcOqUjYGX07tKu5U3wt/HKlIJ1CyfNPmQwCcT9DQ6J/w8zTYVLF9iEOuYxDRnNAT5ZmDkx3gtBl9LcAJ8pRXSDL499MqIjkT7IN8Q/KDI+fn5p7B9mtnPXC8Hg/1VR02GainJbtE+UCNOp3NhVlbWn7wXTtq6lXYWUqUcPQfycugF9mwKtyiOpjzG8WD3EnwNwZchl5P0OHIC71AcNj3E7sZ3gZx3lZXq2pnyJj+pANMAa8b4qVA8VMamBNt3ZsGztNhHRKe3NEUzdFPV3SFO61j1sdBAoTKrvARmPFXai7oRvESzVTlUS1m+HG95v8rYp/O04WF4N9hapmt0dNTDCn7GrocWX0QXwYxEjoQ6wG6DbmAuYZVy+73Dw8Mf0Vov35t+4p0lTh/4PwkRauH3M0sJ8gT0c23Kt/QUenlQT4rDXAO7u/B9HbtPzTYUUyqyfAgUlR9Oo3ycvQR243g65DF6n0DbzEFCeVa/Et84czKwJGJdAs/AvxWdR/yMi0/SdDZ3NwalY2NjlzGWv0frmHK85U4d4oXcl5iY2D0yMmIdGhpycvqcYDHYHIV+ic9vxBxmttLGF/CLYWVlJNupFxl0KUn6hsvlmkeALmYmRjfg1MXTLHs6Q5BH09LSfG63e5y9HsT+CtgH2Gzl3r4M7cBuCb7bSXSC6TInC1qhXkFmZuYovPpzIBeWVexhxerviWCsdIduq1OSPsBeyQMkR38Zhain4X8x/galgVOaBCHfvwAAAABJRU5ErkJggg=="

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./image/426d7e6ee989723f978242d46ba536ef.png";

/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(12);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept(12, function() {
				var newContent = __webpack_require__(12);
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(5)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n *  Font Awesome 4.6.3 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(" + __webpack_require__(13) + ");src:url(" + __webpack_require__(14) + "?#iefix&v=4.6.3) format('embedded-opentype'),url(" + __webpack_require__(15) + ") format('woff2'),url(" + __webpack_require__(16) + ") format('woff'),url(" + __webpack_require__(17) + ") format('truetype'),url(" + __webpack_require__(18) + "#fontawesomeregular) format('svg');font-weight:400;font-style:normal}@font-face{font-family:latolight;src:url(" + __webpack_require__(19) + ");src:url(" + __webpack_require__(19) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(20) + ") format(\"woff\"),url(" + __webpack_require__(21) + ") format(\"truetype\");font-style:normal;font-weight:400}@font-face{font-family:latoregular;src:url(" + __webpack_require__(22) + ");src:url(" + __webpack_require__(22) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(23) + ") format(\"woff\"),url(" + __webpack_require__(24) + ") format(\"truetype\");font-style:normal;font-weight:400}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.33333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.28571429em;text-align:center}.fa-ul{padding-left:0;margin-left:2.14285714em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.14285714em;width:2.14285714em;top:.14285714em;text-align:center}.fa-li.fa-lg{left:-1.85714286em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";-webkit-transform:scaleX(-1);-ms-transform:scaleX(-1);transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";-webkit-transform:scaleY(-1);-ms-transform:scaleY(-1);transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}", ""]);
	
	// exports


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./fonts/fontawesome-webfont.eot";

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./fonts/fontawesome-webfont.eot";

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./fonts/fontawesome-webfont.woff2";

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./fonts/fontawesome-webfont.woff";

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./fonts/fontawesome-webfont.ttf";

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./fonts/fontawesome-webfont.svg";

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./fonts/lato-light-webfont.eot";

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./fonts/lato-light-webfont.woff";

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./fonts/lato-light-webfont.ttf";

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./fonts/lato-regular-webfont.eot";

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./fonts/lato-regular-webfont.woff";

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "./fonts/lato-regular-webfont.ttf";

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Zepto) {//     Zepto.js
	//     (c) 2010-2016 Thomas Fuchs
	//     Zepto.js may be freely distributed under the MIT license.
	
	;(function ($) {
	  var touch = {},
	      touchTimeout,
	      tapTimeout,
	      swipeTimeout,
	      longTapTimeout,
	      longTapDelay = 750,
	      gesture;
	
	  function swipeDirection(x1, x2, y1, y2) {
	    return Math.abs(x1 - x2) >= Math.abs(y1 - y2) ? x1 - x2 > 0 ? 'Left' : 'Right' : y1 - y2 > 0 ? 'Up' : 'Down';
	  }
	
	  function longTap() {
	    longTapTimeout = null;
	    if (touch.last) {
	      touch.el.trigger('longTap');
	      touch = {};
	    }
	  }
	
	  function cancelLongTap() {
	    if (longTapTimeout) clearTimeout(longTapTimeout);
	    longTapTimeout = null;
	  }
	
	  function cancelAll() {
	    if (touchTimeout) clearTimeout(touchTimeout);
	    if (tapTimeout) clearTimeout(tapTimeout);
	    if (swipeTimeout) clearTimeout(swipeTimeout);
	    if (longTapTimeout) clearTimeout(longTapTimeout);
	    touchTimeout = tapTimeout = swipeTimeout = longTapTimeout = null;
	    touch = {};
	  }
	
	  function isPrimaryTouch(event) {
	    return (event.pointerType == 'touch' || event.pointerType == event.MSPOINTER_TYPE_TOUCH) && event.isPrimary;
	  }
	
	  function isPointerEventType(e, type) {
	    return e.type == 'pointer' + type || e.type.toLowerCase() == 'mspointer' + type;
	  }
	
	  $(document).ready(function () {
	    var now,
	        delta,
	        deltaX = 0,
	        deltaY = 0,
	        firstTouch,
	        _isPointerType;
	
	    if ('MSGesture' in window) {
	      gesture = new MSGesture();
	      gesture.target = document.body;
	    }
	
	    $(document).bind('MSGestureEnd', function (e) {
	      var swipeDirectionFromVelocity = e.velocityX > 1 ? 'Right' : e.velocityX < -1 ? 'Left' : e.velocityY > 1 ? 'Down' : e.velocityY < -1 ? 'Up' : null;
	      if (swipeDirectionFromVelocity) {
	        touch.el.trigger('swipe');
	        touch.el.trigger('swipe' + swipeDirectionFromVelocity);
	      }
	    }).on('touchstart MSPointerDown pointerdown', function (e) {
	      if ((_isPointerType = isPointerEventType(e, 'down')) && !isPrimaryTouch(e)) return;
	      firstTouch = _isPointerType ? e : e.touches[0];
	      if (e.touches && e.touches.length === 1 && touch.x2) {
	        // Clear out touch movement data if we have it sticking around
	        // This can occur if touchcancel doesn't fire due to preventDefault, etc.
	        touch.x2 = undefined;
	        touch.y2 = undefined;
	      }
	      now = Date.now();
	      delta = now - (touch.last || now);
	      touch.el = $('tagName' in firstTouch.target ? firstTouch.target : firstTouch.target.parentNode);
	      touchTimeout && clearTimeout(touchTimeout);
	      touch.x1 = firstTouch.pageX;
	      touch.y1 = firstTouch.pageY;
	      if (delta > 0 && delta <= 250) touch.isDoubleTap = true;
	      touch.last = now;
	      longTapTimeout = setTimeout(longTap, longTapDelay);
	      // adds the current touch contact for IE gesture recognition
	      if (gesture && _isPointerType) gesture.addPointer(e.pointerId);
	    }).on('touchmove MSPointerMove pointermove', function (e) {
	      if ((_isPointerType = isPointerEventType(e, 'move')) && !isPrimaryTouch(e)) return;
	      firstTouch = _isPointerType ? e : e.touches[0];
	      cancelLongTap();
	      touch.x2 = firstTouch.pageX;
	      touch.y2 = firstTouch.pageY;
	
	      deltaX += Math.abs(touch.x1 - touch.x2);
	      deltaY += Math.abs(touch.y1 - touch.y2);
	    }).on('touchend MSPointerUp pointerup', function (e) {
	      if ((_isPointerType = isPointerEventType(e, 'up')) && !isPrimaryTouch(e)) return;
	      cancelLongTap();
	
	      // swipe
	      if (touch.x2 && Math.abs(touch.x1 - touch.x2) > 30 || touch.y2 && Math.abs(touch.y1 - touch.y2) > 30) swipeTimeout = setTimeout(function () {
	        if (touch.el) {
	          touch.el.trigger('swipe');
	          touch.el.trigger('swipe' + swipeDirection(touch.x1, touch.x2, touch.y1, touch.y2));
	        }
	        touch = {};
	      }, 0);
	
	      // normal tap
	      else if ('last' in touch)
	          // don't fire tap when delta position changed by more than 30 pixels,
	          // for instance when moving to a point and back to origin
	          if (deltaX < 30 && deltaY < 30) {
	            // delay by one tick so we can cancel the 'tap' event if 'scroll' fires
	            // ('tap' fires before 'scroll')
	            tapTimeout = setTimeout(function () {
	
	              // trigger universal 'tap' with the option to cancelTouch()
	              // (cancelTouch cancels processing of single vs double taps for faster 'tap' response)
	              var event = $.Event('tap');
	              event.cancelTouch = cancelAll;
	              // [by paper] fix -> "TypeError: 'undefined' is not an object (evaluating 'touch.el.trigger'), when double tap
	              if (touch.el) touch.el.trigger(event);
	
	              // trigger double tap immediately
	              if (touch.isDoubleTap) {
	                if (touch.el) touch.el.trigger('doubleTap');
	                touch = {};
	              }
	
	              // trigger single tap after 250ms of inactivity
	              else {
	                  touchTimeout = setTimeout(function () {
	                    touchTimeout = null;
	                    if (touch.el) touch.el.trigger('singleTap');
	                    touch = {};
	                  }, 250);
	                }
	            }, 0);
	          } else {
	            touch = {};
	          }
	      deltaX = deltaY = 0;
	    })
	    // when the browser window loses focus,
	    // for example when a modal dialog is shown,
	    // cancel all ongoing events
	    .on('touchcancel MSPointerCancel pointercancel', cancelAll);
	
	    // scrolling the window indicates intention of the user
	    // to scroll, not tap or swipe, so cancel all ongoing events
	    $(window).on('scroll', cancelAll);
	  });['swipe', 'swipeLeft', 'swipeRight', 'swipeUp', 'swipeDown', 'doubleTap', 'tap', 'singleTap', 'longTap'].forEach(function (eventName) {
	    $.fn[eventName] = function (callback) {
	      return this.on(eventName, callback);
	    };
	  });
	})(Zepto);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// js/common.js